// // import React, { useState, useEffect, useRef, useCallback } from "react";
// // import _ from "lodash";
// // import { ContentState, EditorState, Modifier, SelectionState } from "draft-js";
// // import DocumentService from "../../services/document";
// // import { strCount } from "../Editor/utilize";
// // import { useSelector } from "react-redux";
// // import {
// //   Accordion,
// //   AccordionActions,
// //   AccordionDetails,
// //   AccordionSummary,
// //   Button,
// //   IconButton,
// //   Typography,
// //   Box,
// //   Chip,
// //   Divider,
// //   LinearProgress,
// //   Tooltip,
// //   Fade,
// //   Badge,
// // } from "@mui/material";
// // import { BeatLoader } from "react-spinners";
// // import { css } from "@emotion/react";
// // import GrammarIcon from "@mui/icons-material/Spellcheck";
// // import StyleIcon from "@mui/icons-material/AutoFixHigh";
// // import ClarityIcon from "@mui/icons-material/Visibility";
// // import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
// // import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
// // import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// // import CloseIcon from "@mui/icons-material/Close";
// // import Grid from "@mui/material/Unstable_Grid2";
// // import Popover from "@mui/material/Popover";
// // import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
// // // ─── DESIGN TOKENS ──────────────────────────────────────────────────────────
// // const C = {
// //   bg: "#f0f2f8",
// //   surface: "#ffffff",
// //   border: "rgba(99,120,180,0.14)",
// //   accent: "#4f6ef7",
// //   accentLight: "#cdd3ee",
// //   success: "#22c55e",
// //   successLight: "#f0fdf4",
// //   error: "#ef4444",
// //   errorLight: "#fef2f2",
// //   warning: "#f59e0b",
// //   warningLight: "#fffbeb",
// //   purple: "#8b5cf6",
// //   purpleLight: "#f5f3ff",
// //   textPrimary: "#1a1d2e",
// //   textSecondary: "#64748b",
// //   textMuted: "#434343",
// // };

// // const R = { sm: "8px", md: "12px", lg: "16px" };

// // // ─── ERROR TYPE CONFIG ────────────────────────────────────────────────────────
// // const getErrorConfig = (type = "") => {
// //   const t = type.toLowerCase();
// //   if (t.includes("grammar") || t.includes("grammatical"))
// //     return {
// //       color: C.error,
// //       bg: C.errorLight,
// //       label: "Grammar",
// //       icon: <GrammarIcon sx={{ fontSize: 13 }} />,
// //     };
// //   if (t.includes("spell"))
// //     return {
// //       color: C.warning,
// //       bg: C.warningLight,
// //       label: "Spelling",
// //       icon: <GrammarIcon sx={{ fontSize: 13 }} />,
// //     };
// //   if (t.includes("style"))
// //     return {
// //       color: C.purple,
// //       bg: C.purpleLight,
// //       label: "Style",
// //       icon: <StyleIcon sx={{ fontSize: 13 }} />,
// //     };
// //   if (t.includes("clarity"))
// //     return {
// //       color: C.accent,
// //       bg: C.accentLight,
// //       label: "Clarity",
// //       icon: <ClarityIcon sx={{ fontSize: 13 }} />,
// //     };
// //   return {
// //     color: C.textSecondary,
// //     bg: "#f8fafc",
// //     label: type || "Issue",
// //     icon: <SwapHorizIcon sx={{ fontSize: 13 }} />,
// //   };
// // };

// // const override = css`
// //   position: absolute;
// //   left: 42%;
// //   top: 50%;
// //   margin: 0 auto;
// //   z-index: 9999;
// // `;

// // // ─── EMPTY STATE ─────────────────────────────────────────────────────────────
// // const EmptyState = () => (
// //   <Box
// //     sx={{
// //       display: "flex",
// //       flexDirection: "column",
// //       alignItems: "center",
// //       justifyContent: "center",
// //       py: 6,
// //       px: 3,
// //       gap: 1.5,
// //     }}
// //   >
// //     <Box
// //       sx={{
// //         width: 56,
// //         height: 56,
// //         borderRadius: "50%",
// //         bgcolor: C.successLight,
// //         display: "flex",
// //         alignItems: "center",
// //         justifyContent: "center",
// //         mb: 0.5,
// //       }}
// //     >
// //       <CheckCircleOutlineIcon sx={{ fontSize: 28, color: C.success }} />
// //     </Box>
// //     <Typography
// //       sx={{ fontWeight: 700, color: C.textPrimary, fontSize: "0.95rem" }}
// //     >
// //       All good!
// //     </Typography>
// //     <Typography
// //       sx={{
// //         color: C.textMuted,
// //         fontSize: "0.82rem",
// //         textAlign: "center",
// //         lineHeight: 1.5,
// //       }}
// //     >
// //       No suggestions found. Your writing looks great.
// //     </Typography>
// //   </Box>
// // );

// // const InlineGrammarPopup = ({
// //   popup,
// //   onClose,
// //   onReplace,
// //   onIgnore,
// //   onExplain,
// // }) => {
// //   if (!popup?.visible || !popup?.suggestion) return null;

// //   return (
// //     <Box
// //       onMouseDown={(e) => e.preventDefault()}
// //       sx={{
// //         position: "fixed",
// //         top: popup.y,
// //         left: popup.x,
// //         transform: "translate(-50%, -112%)",
// //         zIndex: 9999,
// //         minWidth: 300,
// //         maxWidth: 360,
// //         borderRadius: "18px",
// //         background: "rgba(255,255,255,0.96)",
// //         border: `1px solid ${C.border}`,
// //         boxShadow: "0 20px 55px rgba(91,111,232,0.18)",
// //         backdropFilter: "blur(14px)",
// //         overflow: "visible",
// //         "&::after": {
// //           content: '""',
// //           position: "absolute",
// //           left: "50%",
// //           bottom: -7,
// //           width: 14,
// //           height: 14,
// //           background: "rgba(255,255,255,0.96)",
// //           borderRight: `1px solid ${C.border}`,
// //           borderBottom: `1px solid ${C.border}`,
// //           transform: "translateX(-50%) rotate(45deg)",
// //         },
// //       }}
// //     >
// //       <Box
// //         sx={{
// //           display: "flex",
// //           alignItems: "center",
// //           justifyContent: "space-between",
// //           px: 1.5,
// //           pt: 1.05,
// //           pb: 0.55,
// //           borderBottom: `1px solid ${C.border}`,
// //         }}
// //       >
// //         <Typography
// //           sx={{ fontSize: "12px", fontWeight: 700, color: C.textMuted }}
// //         >
// //           Suggestion:
// //         </Typography>
// //         <IconButton
// //           size="small"
// //           onClick={onClose}
// //           sx={{
// //             width: 28,
// //             height: 28,
// //             color: C.textMuted,
// //             "&:hover": { color: C.error, bgcolor: C.errorLight },
// //           }}
// //         >
// //           <CloseIcon sx={{ fontSize: 15 }} />
// //         </IconButton>
// //       </Box>

// //       <Box
// //         sx={{
// //           mx: 1.5,
// //           my: 0.9,
// //           px: 1.2,
// //           py: 1,
// //           borderRadius: R.md,
// //           background: "#f9faff",
// //           border: `1px solid ${C.border}`,
// //         }}
// //       >
// //         <Typography
// //           sx={{ fontSize: "0.95rem", fontWeight: 500, color: C.textPrimary }}
// //         >
// //           &ldquo;{popup.suggestion.value || popup.suggestion.errored_text || ""}
// //           &rdquo;
// //         </Typography>
// //       </Box>

// //       <Box sx={{ px: 1.5, pb: 1.4, display: "flex", gap: 0.75 }}>
// //         <Button
// //           onClick={onReplace}
// //           startIcon={<SwapHorizIcon sx={{ fontSize: 15 }} />}
// //           sx={{
// //             flex: 1,
// //             borderRadius: "12px",
// //             textTransform: "none",
// //             fontWeight: 700,
// //             fontSize: "12.5px",
// //             py: 0.72,
// //             color: "#fff",
// //             background: `linear-gradient(135deg, ${C.accent} 0%, #6f86ff 100%)`,
// //             boxShadow: "0 10px 22px rgba(91,111,232,0.22)",
// //             "&:hover": {
// //               background: `linear-gradient(135deg, #445ee5 0%, ${C.accent} 100%)`,
// //             },
// //           }}
// //         >
// //           Replace
// //         </Button>
// //         <Button
// //           onClick={onIgnore}
// //           sx={{
// //             flex: 1,
// //             borderRadius: "12px",
// //             textTransform: "none",
// //             fontWeight: 600,
// //             fontSize: "12.5px",
// //             py: 0.72,
// //             color: C.textSecondary,
// //             background: C.surface,
// //             border: `1px solid ${C.border}`,
// //             "&:hover": { background: "#f5f7ff", borderColor: C.accent },
// //           }}
// //         >
// //           Ignore
// //         </Button>
// //         <Button
// //           onClick={onExplain}
// //           startIcon={<ClarityIcon sx={{ fontSize: 15 }} />}
// //           sx={{
// //             flex: 1,
// //             borderRadius: "12px",
// //             textTransform: "none",
// //             fontWeight: 600,
// //             fontSize: "12.5px",
// //             py: 0.72,
// //             color: C.accent,
// //             background: C.surface,
// //             border: `1px solid ${C.border}`,
// //             "&:hover": { background: C.accentLight, borderColor: C.accent },
// //           }}
// //         >
// //           Explain
// //         </Button>
// //       </Box>
// //     </Box>
// //   );
// // };

// // // ─── SUGGESTION CARD ─────────────────────────────────────────────────────────
// // const SuggestionCard = ({
// //   suggestion,
// //   expanded,
// //   onExpand,
// //   onAccept,
// //   onIgnore,
// //   mobileView,
// // }) => {
// //   const config = getErrorConfig(suggestion.type_of_error);

// //   return (
// //     <Accordion
// //       expanded={expanded === suggestion.errored_text}
// //       onChange={() => onExpand(suggestion)}
// //       id={`accordion-${suggestion.errored_text}`}
// //       disableGutters
// //       elevation={0}
// //       sx={{
// //         border: `1.5px solid ${expanded === suggestion.errored_text ? config.color + "40" : C.border}`,
// //         borderRadius: `${R.md} !important`,
// //         mb: 1.25,
// //         overflow: "hidden",
// //         transition: "all 0.2s ease",
// //         "&:before": { display: "none" },
// //         "&.Mui-expanded": {
// //           boxShadow: `0 4px 16px ${config.color}18`,
// //         },
// //       }}
// //     >
// //       <AccordionSummary
// //         expandIcon={
// //           <ExpandMoreIcon
// //             sx={{
// //               fontSize: 18,
// //               color:
// //                 expanded === suggestion.errored_text
// //                   ? config.color
// //                   : C.textMuted,
// //               transition: "color 0.2s",
// //             }}
// //           />
// //         }
// //         sx={{
// //           px: 2,
// //           py: 0.5,
// //           minHeight: 52,
// //           bgcolor: expanded === suggestion.errored_text ? config.bg : C.surface,
// //           transition: "background-color 0.2s",
// //           "&:hover": { bgcolor: config.bg },
// //           "& .MuiAccordionSummary-content": {
// //             margin: "10px 0",
// //             alignItems: "center",
// //             gap: 1,
// //           },
// //         }}
// //       >
// //         <Box sx={{ flex: 1, minWidth: 0 }}>
// //           <Typography
// //             sx={{
// //               fontWeight: 600,
// //               fontSize: "0.83rem",
// //               color: config.color,
// //               textDecoration: "line-through",
// //               textDecorationColor: config.color + "80",
// //               letterSpacing: "-0.01em",
// //               whiteSpace: "normal",
// //               overflowWrap: "break-word",
// //             }}
// //           >
// //             {suggestion.errored_text}
// //           </Typography>
// //         </Box>
// //         <Chip
// //           icon={config.icon}
// //           label={config.label}
// //           size="small"
// //           sx={{
// //             height: 22,
// //             fontSize: "0.7rem",
// //             fontWeight: 700,
// //             bgcolor: config.bg,
// //             color: config.color,
// //             border: `1px solid ${config.color}30`,
// //             "& .MuiChip-icon": { color: config.color, ml: 0.5 },
// //             flexShrink: 0,
// //           }}
// //         />
// //       </AccordionSummary>

// //       <AccordionDetails
// //         sx={{
// //           px: 2,
// //           py: 1.5,
// //           bgcolor: C.surface,
// //           borderTop: `1px solid ${C.border}`,
// //         }}
// //       >
// //         {/* Replace with */}
// //         <Box
// //           sx={{
// //             display: "flex",
// //             alignItems: "flex-start",
// //             gap: 1,
// //             mb: 1.5,
// //             p: 1.25,
// //             borderRadius: R.sm,
// //             bgcolor: C.accentLight,
// //             border: `1px solid ${C.accent}25`,
// //           }}
// //         >
// //           <SwapHorizIcon
// //             sx={{ fontSize: 16, color: C.accent, mt: 0.15, flexShrink: 0 }}
// //           />
// //           <Box>
// //             <Typography
// //               sx={{
// //                 fontSize: "0.72rem",
// //                 fontWeight: 600,
// //                 color: C.textMuted,
// //                 mb: 0.25,
// //                 textTransform: "uppercase",
// //                 letterSpacing: "0.04em",
// //               }}
// //             >
// //               Replace with
// //             </Typography>
// //             <Typography
// //               sx={{ fontSize: "0.85rem", fontWeight: 700, color: C.accent }}
// //             >
// //               &ldquo;{suggestion.corrective_text}&rdquo;
// //             </Typography>
// //           </Box>
// //         </Box>

// //         {/* Justification */}
// //         {suggestion.justification && (
// //           <Box sx={{ mb: 0.5 }}>
// //             <Typography
// //               sx={{
// //                 fontSize: "0.72rem",
// //                 fontWeight: 600,
// //                 color: C.textMuted,
// //                 mb: 0.5,
// //                 textTransform: "uppercase",
// //                 letterSpacing: "0.04em",
// //               }}
// //             >
// //               Why
// //             </Typography>
// //             <Typography
// //               sx={{
// //                 fontSize: "0.82rem",
// //                 color: C.textSecondary,
// //                 lineHeight: 1.55,
// //               }}
// //             >
// //               {suggestion.justification}
// //             </Typography>
// //           </Box>
// //         )}
// //       </AccordionDetails>

// //       <AccordionActions
// //         sx={{
// //           px: 2,
// //           py: 1.25,
// //           bgcolor: "#fafbff",
// //           borderTop: `1px solid ${C.border}`,
// //           gap: 1,
// //         }}
// //       >
// //         <Button
// //           size="small"
// //           variant="outlined"
// //           onClick={() => onIgnore(suggestion)}
// //           sx={{
// //             borderRadius: R.md,
// //             textTransform: "none",
// //             fontWeight: 600,
// //             fontSize: "0.78rem",
// //             flex: 1,
// //             borderWidth: 1.5,
// //             borderColor: C.error + "60",
// //             color: C.error,
// //             "&:hover": {
// //               borderColor: C.error,
// //               bgcolor: C.errorLight,
// //             },
// //           }}
// //         >
// //           Ignore
// //         </Button>
// //         <Button
// //           size="small"
// //           variant="contained"
// //           onClick={() => onAccept(suggestion)}
// //           sx={{
// //             borderRadius: R.md,
// //             textTransform: "none",
// //             fontWeight: 600,
// //             fontSize: "0.78rem",
// //             flex: 1,
// //             bgcolor: C.accent,
// //             boxShadow: "none",
// //             "&:hover": {
// //               bgcolor: C.accentDark,
// //               boxShadow: "none",
// //             },
// //           }}
// //         >
// //           Accept
// //         </Button>
// //       </AccordionActions>
// //     </Accordion>
// //   );
// // };

// // // ────────────────────────────────────────────────────────────────────────────
// // // MAIN SuggestionComp
// // // ────────────────────────────────────────────────────────────────────────────
// // const SuggestionComp = ({
// //   mobileView,
// //   autoSaveContent,
// //   docName,
// //   docId,
// //   newDocId,
// //   folderId,
// //   tags,
// //   ignoreAllClicked,
// //   setIgnoreAllClicked,
// //   acceptAllClicked,
// //   setAcceptAllClicked,
// //   setEditorContentUpload,
// //   editorContent,
// //   changedSentence,
// //   setSentenceResult,
// //   setState,
// //   setIsFeatureButton,
// //   editorState,
// //   setEditorState,
// //   setIsSuggestion,
// //   copiedText,
// //   editor,
// //   setIsType,
// //   ignoredSuggestions,
// //   windowWidth,
// //   setOldSentences,
// //   oldSentences,
// //   setNewSentences,
// //   newSentences,
// //   suggestionLoader,
// //   editorValue,
// //   isStreaming,
// // }) => {
// //   const escapeRegex = (value = "") =>
// //     value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
// //   const getSuggestionValue = (item = {}) =>
// //     item.value ||
// //     item.errored_text ||
// //     item.original_text ||
// //     item.incorrect ||
// //     item.actual ||
// //     item.phrase ||
// //     "";
// //   const getSuggestionCorrection = (item = {}) =>
// //     item.corrective_text ||
// //     item.corrective_text_phrase ||
// //     item.corrected_text ||
// //     item.suggestion ||
// //     item.expected?.[0] ||
// //     "";
// //   const getSuggestionMatchText = (item = {}) =>
// //     item.phrase ||
// //     item.value ||
// //     item.errored_text ||
// //     item.original_text ||
// //     item.incorrect ||
// //     item.actual ||
// //     "";
// //   const getSuggestionReplacementText = (item = {}) =>
// //     item.corrective_text_phrase ||
// //     item.corrective_text ||
// //     item.corrected_text ||
// //     item.suggestion ||
// //     item.expected?.[0] ||
// //     "";
// //   const getSuggestionKey = (item = {}) =>
// //     `${getSuggestionValue(item)}|${getSuggestionCorrection(item)}`;

// //   const [suggestionArray, setSuggestionArray] = useState([]);
// //   const [isColorChange, setIsColorChange] = useState(true);
// //   const [clickedWord, setClickedWord] = useState("");
// //   const { isFullSize } = useSelector((state) => state?.manageFullSizeEditor);
// //   const { isFullScreen } = useSelector((state) => state?.manageFullSizeEditor);
// //   const [expanded, setExpanded] = useState();
// //   const [errorValue, setErrorValue] = useState("");
// //   const [inlinePopup, setInlinePopup] = useState({
// //     visible: false,
// //     x: 0,
// //     y: 0,
// //     suggestion: null,
// //   });

// //   // let filterValues = [];
// //   const accordionRef = useRef(null);

// //   const [wordsCount, characterCount] = strCount(editorContent.toString());

// //   // ── all original logic (unchanged) ──────────────────────────────────────
// //   useEffect(() => {
// //     if (acceptAllClicked) {
// //       handleAcceptAll(suggestionArray);
// //       setAcceptAllClicked(false);
// //     }
// //   }, [acceptAllClicked]);
// //   useEffect(() => {
// //     if (ignoreAllClicked) {
// //       handleIgnoreAll(suggestionArray);
// //       setIgnoreAllClicked(false);
// //     }
// //   }, [ignoreAllClicked]);

// //   useEffect(() => {
// //     const handleClick = (event) => {
// //       const el = event.target.closest(".highlighted-error");
// //       if (!el) return;

// //       const selectedText = window.getSelection?.()?.toString()?.trim();
// //       if (selectedText) {
// //         return;
// //       }

// //       event.preventDefault();
// //       event.stopPropagation();

// //       const word = decodeURIComponent(el.dataset.word || "");
// //       const displayWord = decodeURIComponent(el.dataset.displayWord || "");
// //       const match =
// //         suggestionArray.find(
// //           (item) =>
// //             item.errored_text === word ||
// //             item.value === displayWord ||
// //             item.value === word,
// //         ) || null;
// //       const rect = el.getBoundingClientRect();

// //       console.log("Clicked:", word, displayWord);
// //       if (match) {
// //         setInlinePopup({
// //           visible: true,
// //           x: rect.left + rect.width / 2,
// //           y: rect.top,
// //           suggestion: match,
// //         });
// //       }
// //       scrollToAccordion(word, displayWord);
// //     };

// //     document.addEventListener("click", handleClick);
// //     return () => {
// //       document.removeEventListener("click", handleClick);
// //     };
// //   }, [suggestionArray]);

// //   const handleIgnoreAll = async (suggestions) => {
// //     suggestions.forEach(async (sentence) => {
// //       let filterSentence = suggestionArray.filter(
// //         (item) => item.value !== sentence.value,
// //       );
// //       setSuggestionArray(filterSentence);
// //       if (filterSentence.length === 0) {
// //         setSentenceResult([]);
// //         setIsSuggestion(false);
// //       }
// //       colorWord(sentence.value, sentence.errored_text, "black");
// //       highLightWords(sentence.value, "white");
// //     });
// //     setSentenceResult([]);
// //     setIsColorChange(false);
// //     setIsSuggestion(false);
// //   };

// //   const handleAcceptAll = (suggestions) => {
// //     if (!editor.current || !Array.isArray(suggestions)) return;

// //     const root = editor.current;

// //     suggestions.forEach((sentence) => {
// //       sentence = {
// //         ...sentence,
// //         value: getSuggestionValue(sentence),
// //         corrective_text: getSuggestionCorrection(sentence),
// //       };
// //       const wrongText = getSuggestionMatchText(sentence);
// //       const correctText = getSuggestionReplacementText(sentence);

// //       if (!wrongText || !correctText) return;

// //       const walker = document.createTreeWalker(
// //         root,
// //         NodeFilter.SHOW_TEXT,
// //         null,
// //         false,
// //       );

// //       let node;

// //       while ((node = walker.nextNode())) {
// //         const text = node.nodeValue;

// //         if (!text.toLowerCase().includes(wrongText.toLowerCase())) continue;

// //         const updatedText = text.replace(
// //           new RegExp(escapeRegex(wrongText), "gi"),
// //           correctText,
// //         );

// //         node.nodeValue = updatedText;
// //       }
// //     });

// //     // ✅ STEP 2: Clean ALL spans (remove red + background)
// //     const spans = root.querySelectorAll("span");

// //     spans.forEach((span) => {
// //       const textNode = document.createTextNode(span.textContent);
// //       span.replaceWith(textNode);
// //     });

// //     // ✅ STEP 3: Reset states
// //     setSuggestionArray([]);
// //     setSentenceResult([]);
// //     setIsSuggestion(false);
// //     setIsColorChange(false);

// //     // ✅ STEP 4: Track updated sentences
// //     const allCorrections = suggestions.map((s) => getSuggestionCorrection(s));

// //     setNewSentences((prev) => [...prev, ...allCorrections]);
// //   };

// //   // const colorWord = (word, errorWord, color) => {
// //   //   if (!editor.current) return;

// //   //   let content = editor.current.innerHTML;
// //   //   const escapedWord = escapeRegex(word);
// //   //   const rawErrorWord = errorWord || "";
// //   //   const encodedErrorWord = encodeURIComponent(rawErrorWord);
// //   //   const encodedDisplayWord = encodeURIComponent(word || "");
// //   //   const escapedRawErrorWord = escapeRegex(rawErrorWord);
// //   //   const escapedEncodedErrorWord = escapeRegex(encodedErrorWord);
// //   //   const spanRemovalRegex = new RegExp(
// //   //     `<span[^>]*?data-word=["'](?:${escapedRawErrorWord}|${escapedEncodedErrorWord})["'][^>]*?>(.*?)<\\/span>`,
// //   //     "gi",
// //   //   );
// //   //   content = content.replace(spanRemovalRegex, "$1");
// //   //   const replacement = `<span onclick="window.handleHighlightedWordClick(event,this)" data-word="${encodedErrorWord}" data-display-word="${encodedDisplayWord}" style="color: ${color}; cursor:pointer">${word}</span>`;
// //   //   const coloredContent = content.replace(
// //   //     new RegExp(`(${escapedWord})(?![^<]*>)`, "gi"),
// //   //     replacement,
// //   //   );
// //   //   editor.current.innerHTML = coloredContent;
// //   // };

// //   // const handleAcceptAll = (suggestions) => {
// //   //   if (!editor.current || !Array.isArray(suggestions)) return;
// //   //   const root = editor.current;
// //   //   suggestions.forEach((sentence) => {
// //   //     const wrongSentence = sentence.phrase;
// //   //     const correctSentence = sentence.corrective_text_phrase;

// //   //     if (!wrongSentence || !correctSentence) return;

// //   //     const walker = document.createTreeWalker(
// //   //       root,
// //   //       NodeFilter.SHOW_TEXT,
// //   //       null,
// //   //       false,
// //   //     );

// //   //     let node;

// //   //     while ((node = walker.nextNode())) {
// //   //       const text = node.nodeValue;

// //   //       if (!text.toLowerCase().includes(wrongSentence.toLowerCase())) continue;

// //   //       const updatedText = text.replace(
// //   //         new RegExp(escapeRegex(wrongSentence), "gi"),
// //   //         correctSentence,
// //   //       );

// //   //       node.nodeValue = updatedText;
// //   //     }
// //   //   });

// //   //   // 👉 remove all highlight + color spans (clean UI)
// //   //   const spans = root.querySelectorAll("span");

// //   //   spans.forEach((span) => {
// //   //     const textNode = document.createTextNode(span.textContent);
// //   //     span.replaceWith(textNode);
// //   //   });

// //   //   // 👉 update state
// //   //   setSentenceResult([]);
// //   //   setIsColorChange(false);
// //   //   setIsSuggestion(false);
// //   //   setSuggestionArray([]);

// //   //   // optional
// //   //   setNewSentences((prev) => [
// //   //     ...prev,
// //   //     ...suggestions.map((s) => s.corrective_text_phrase),
// //   //   ]);
// //   // };

// //   // const colorWord = (word, errorWord, color) => {
// //   //   if (!editor.current || !word) return;

// //   //   const root = editor.current;
// //   //   const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);

// //   //   let node;
// //   //   while ((node = walker.nextNode())) {
// //   //     const text = node.nodeValue;

// //   //     if (!text.toLowerCase().includes(word.toLowerCase())) continue;

// //   //     const parts = text.split(new RegExp(`(${escapeRegex(word)})`, "gi"));
// //   //     const fragment = document.createDocumentFragment();

// //   //     parts.forEach((part) => {
// //   //       if (part.toLowerCase() === word.toLowerCase()) {
// //   //         const span = document.createElement("span");
// //   //         span.style.color = color;
// //   //         span.style.cursor = "pointer";
// //   //         span.setAttribute("data-word", errorWord);
// //   //         span.setAttribute("data-display-word", word);

// //   //         span.onclick = (e) => window.handleHighlightedWordClick(e, span);

// //   //         span.textContent = part;
// //   //         fragment.appendChild(span);
// //   //       } else {
// //   //         fragment.appendChild(document.createTextNode(part));
// //   //       }
// //   //     });

// //   //     node.replaceWith(fragment);
// //   //   }
// //   // };

// //   // window.handleHighlightedWordClick = (event, el) => {
// //   //   event.preventDefault();
// //   //   event.stopPropagation();
// //   //   const word = decodeURIComponent(el.dataset.word);
// //   //   const clickedDisplayWord = decodeURIComponent(el.dataset.displayWord || "");
// //   //   scrollToAccordion(word, clickedDisplayWord);
// //   // };

// //   const colorWord = (word, errorWord, color) => {
// //     if (!editor.current || !word) return;

// //     const root = editor.current;
// //     const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);

// //     let node;
// //     while ((node = walker.nextNode())) {
// //       const text = node.nodeValue;

// //       if (!text.toLowerCase().includes(word.toLowerCase())) continue;

// //       const parts = text.split(new RegExp(`(${escapeRegex(word)})`, "gi"));
// //       const fragment = document.createDocumentFragment();

// //       parts.forEach((part) => {
// //         if (part.toLowerCase() === word.toLowerCase()) {
// //           const span = document.createElement("span");

// //           span.style.color = color;
// //           span.style.cursor = "text";
// //           span.style.userSelect = "text";
// //           span.style.webkitUserSelect = "text";

// //           // ✅ IMPORTANT
// //           span.dataset.displayWord = encodeURIComponent(word || "");
// //           span.dataset.word = encodeURIComponent(errorWord || "");

// //           span.className = "highlighted-error"; // 🔥 add class

// //           span.textContent = part;

// //           fragment.appendChild(span);
// //         } else {
// //           fragment.appendChild(document.createTextNode(part));
// //         }
// //       });
// //       node.replaceWith(fragment);
// //     }
// //   };

// //   window.handleHighlightedWordClick = (event, el) => {
// //     console.log("eventWord_", el.dataset);
// //     event.preventDefault();
// //     event.stopPropagation();
// //     const word = decodeURIComponent(el.dataset.word);
// //     const clickedDisplayWord = decodeURIComponent(el.dataset.displayWord || "");
// //     scrollToAccordion(word, clickedDisplayWord);
// //   };

// //   // const highLightWords = (word, color) => {
// //   //   if (!editor.current || !word) return;

// //   //   let content = editor.current.innerHTML;
// //   //   const escapedWord = escapeRegex(word);
// //   //   const replacement = `<span style="background-color:${color};">${word}</span>`;
// //   //   const coloredContent = content?.replace(
// //   //     new RegExp(`(${escapedWord})(?![^<]*>)`, "gi"),
// //   //     replacement,
// //   //   );
// //   //   const selection = window.getSelection();
// //   //   selection.removeAllRanges();
// //   //   editor.current.innerHTML = coloredContent;
// //   // };
// //   const lastHighlightedRef = useRef(null);

// //   const highLightWords = (word, color) => {
// //     if (!editor.current || !word) return;

// //     // ✅ remove previous highlight
// //     if (lastHighlightedRef.current) {
// //       lastHighlightedRef.current.style.backgroundColor = "";
// //     }

// //     const encodedWord = encodeURIComponent(word);

// //     const el = editor.current.querySelector(
// //       `span[data-display-word="${encodedWord}"]`,
// //     );

// //     if (el) {
// //       el.style.backgroundColor = color;
// //       lastHighlightedRef.current = el; // ✅ store reference
// //     }
// //   };

// //   const focusEditorOnSuggestion = (word, displayword) => {
// //     if (!editor.current) return null;

// //     const root = editor.current;
// //     const candidates = [
// //       displayword
// //         ? `span[data-display-word="${encodeURIComponent(displayword)}"]`
// //         : null,
// //       word ? `span[data-word="${encodeURIComponent(word)}"]` : null,
// //       word ? `span[data-display-word="${encodeURIComponent(word)}"]` : null,
// //     ].filter(Boolean);

// //     let target = null;

// //     for (const selector of candidates) {
// //       target = root.querySelector(selector);
// //       if (target) break;
// //     }

// //     if (!target && displayword) {
// //       const spans = Array.from(root.querySelectorAll(".highlighted-error"));
// //       target =
// //         spans.find(
// //           (span) =>
// //             decodeURIComponent(span.dataset.displayWord || "") === displayword,
// //         ) ||
// //         spans.find(
// //           (span) => decodeURIComponent(span.dataset.word || "") === word,
// //         ) ||
// //         null;
// //     }

// //     if (!target) return null;

// //     target.scrollIntoView({
// //       behavior: "smooth",
// //       block: "center",
// //       inline: "nearest",
// //     });

// //     const range = document.createRange();
// //     range.selectNodeContents(target);

// //     const selection = window.getSelection();
// //     if (selection) {
// //       selection.removeAllRanges();
// //       selection.addRange(range);
// //     }

// //     root.focus();
// //     return target;
// //   };

// //   const scrollToAccordion = (word, displayword) => {
// //     const accordionItems = document.querySelectorAll(
// //       `.cgsuggestion [id^="accordion-"]`,
// //     );
// //     let foundItem = null;
// //     accordionItems.forEach((item) => {
// //       const erroredText = item.id.replace("accordion-", "");
// //       if (erroredText === word && !foundItem) foundItem = item;
// //     });
// //     if (foundItem) {
// //       foundItem.scrollIntoView({ behavior: "smooth", block: "center" });
// //       const accordionSummary = foundItem.querySelector(
// //         ".MuiAccordionSummary-root",
// //       );
// //       if (accordionSummary) {
// //         accordionSummary.style.backgroundColor = "#e6f7ff";
// //         setTimeout(() => {
// //           accordionSummary.style.backgroundColor = "";
// //         }, 1000);
// //       }
// //       if (expanded !== word) {
// //         setExpanded(word);
// //         highLightWords(displayword, C.accentLight);
// //       }
// //     }

// //     focusEditorOnSuggestion(word, displayword);
// //   };

// //   // const handleAccept = (sentence) => {
// //   //   console.log("Accept_Click_", sentence);
// //   //   if (!editor.current) return;
// //   //   const wrongSentence = sentence.phrase;
// //   //   const correctSentence = sentence.corrective_text_phrase;
// //   //   const root = editor.current;
// //   //   const text = root.innerText;
// //   //   const escaped = escapeRegex(wrongSentence || "");
// //   //   const updatedText = text.replace(
// //   //     new RegExp(escaped, "gi"),
// //   //     correctSentence,
// //   //   );
// //   //   root.innerHTML = updatedText;
// //   //   const filterSentence = suggestionArray.filter(
// //   //     (item) => item.corrective_text !== sentence.corrective_text,
// //   //   );
// //   //   if (filterSentence.length === 0) {
// //   //     setSentenceResult([]);
// //   //     setIsColorChange(false);
// //   //     setIsSuggestion(false);
// //   //   }
// //   //   setSuggestionArray(filterSentence);
// //   //   setNewSentences((prev) => [...prev, correctSentence]);
// //   // };

// //   // const handleAccept = (sentence) => {
// //   //   if (!editor.current) return;

// //   //   const correctText = sentence.corrective_text_phrase;
// //   //   const root = editor.current;

// //   //   // 👉 find EXACT clicked/highlighted element
// //   //   const highlighted = root.querySelector(
// //   //     'span[style*="background-color"]'
// //   //   );

// //   //   if (!highlighted) {
// //   //     console.log("❌ No highlighted element found");
// //   //     return;
// //   //   }

// //   //   // 👉 IMPORTANT: replace WHOLE phrase safely
// //   //   const range = document.createRange();
// //   //   range.selectNode(highlighted);

// //   //   // 👉 replace with correct phrase
// //   //   range.deleteContents();
// //   //   range.insertNode(document.createTextNode(correctText));

// //   //   // 👉 cleanup: remove ALL spans (no duplicate, no red)
// //   //   const spans = root.querySelectorAll("span");
// //   //   spans.forEach((span) => {
// //   //     span.replaceWith(document.createTextNode(span.textContent));
// //   //   });

// //   //   // 👉 update state
// //   //   const filterSentence = suggestionArray.filter(
// //   //     (item) => item.corrective_text !== sentence.corrective_text
// //   //   );

// //   //   if (filterSentence.length === 0) {
// //   //     setSentenceResult([]);
// //   //     setIsColorChange(false);
// //   //     setIsSuggestion(false);
// //   //   }

// //   //   setSuggestionArray(filterSentence);
// //   //   setNewSentences((prev) => [...prev, correctText]);
// //   // };

// //   const handleAccept = (sentence) => {
// //     if (!editor.current) return;

// //     sentence = {
// //       ...sentence,
// //       value: getSuggestionValue(sentence),
// //       corrective_text: getSuggestionCorrection(sentence),
// //     };

// //     const wrongText = getSuggestionMatchText(sentence);
// //     const correctText = getSuggestionReplacementText(sentence);

// //     const root = editor.current;

// //     // ✅ STEP 1: Replace only text nodes (preserve HTML)
// //     const walker = document.createTreeWalker(
// //       root,
// //       NodeFilter.SHOW_TEXT,
// //       null,
// //       false,
// //     );

// //     let node;

// //     while ((node = walker.nextNode())) {
// //       const text = node.nodeValue;

// //       if (!text.toLowerCase().includes(wrongText.toLowerCase())) continue;

// //       const updatedText = text.replace(
// //         new RegExp(escapeRegex(wrongText), "gi"),
// //         correctText,
// //       );

// //       node.nodeValue = updatedText;
// //     }

// //     // ✅ STEP 2: Remove ONLY red color spans (clean UI)
// //     const spans = root.querySelectorAll("span");

// //     spans.forEach((span) => {
// //       // remove background highlight
// //       span.style.backgroundColor = "";

// //       // remove red color
// //       span.style.color = "";

// //       // 👉 OPTIONAL (recommended): remove span completely
// //       const textNode = document.createTextNode(span.textContent);
// //       span.replaceWith(textNode);
// //     });

// //     // ✅ STEP 3: Update suggestion list
// //     const filterSentence = suggestionArray.filter(
// //       (item) => getSuggestionKey(item) !== getSuggestionKey(sentence),
// //     );

// //     if (filterSentence.length === 0) {
// //       setSentenceResult([]);
// //       setIsColorChange(false);
// //       setIsSuggestion(false);
// //     }

// //     setSuggestionArray(filterSentence);
// //     setInlinePopup((prev) => ({
// //       ...prev,
// //       visible: false,
// //       suggestion:
// //         getSuggestionKey(prev?.suggestion || {}) === getSuggestionKey(sentence)
// //           ? null
// //           : prev.suggestion,
// //     }));

// //     // ✅ STEP 4: Track corrected text
// //     setNewSentences((prev) => [...prev, correctText]);
// //   };

// //   const handleIgnore = async (sentence) => {
// //     let filterSentence = _.filter(
// //       suggestionArray,
// //       (item) => item.value !== sentence.value,
// //     );
// //     if (filterSentence.length == 0) {
// //       setSentenceResult([]);
// //       setIsSuggestion(false);
// //     }
// //     colorWord(sentence.value, sentence.errored_text, "black");
// //     highLightWords(sentence.value, "white");
// //     setSuggestionArray(filterSentence);
// //     setInlinePopup((prev) => ({
// //       ...prev,
// //       visible: false,
// //       suggestion:
// //         prev?.suggestion?.value === sentence.value ? null : prev.suggestion,
// //     }));
// //   };

// //   // useEffect(() => {
// //   //   if (changedSentence?.length > 0) handleFilterValues(changedSentence);
// //   // }, [changedSentence]);

// //   const lastProcessedRef = useRef(0);

// //   useEffect(() => {
// //     if (!Array.isArray(changedSentence)) return;

// //     if (changedSentence.length === 0) {
// //       setSuggestionArray([]);
// //       lastProcessedRef.current = 0;
// //       return;
// //     }

// //     const fresh = changedSentence.slice(lastProcessedRef.current);

// //     if (fresh.length > 0) {
// //       handleFilterValues(fresh);
// //       lastProcessedRef.current = changedSentence.length;
// //     }
// //   }, [changedSentence]);

// //   const handleFilterValues = (sentence) => {
// //     const filterValues = sentence.map((item) => ({
// //       corrective_text:
// //         item.corrective_text ||
// //         item.corrective_text_phrase ||
// //         item.corrected_text ||
// //         item.suggestion ||
// //         item.expected?.[0] ||
// //         "",
// //       corrective_text_phrase:
// //         item.corrective_text_phrase || item.corrected_text || "",
// //       justification: item.justification || "",
// //       phrase: item.phrase || "",
// //       type_of_error: item.type_of_error || "",
// //       value:
// //         item.value ||
// //         item.errored_text ||
// //         item.original_text ||
// //         item.incorrect ||
// //         item.actual ||
// //         item.phrase ||
// //         "",
// //       errored_text:
// //         item.errored_text ||
// //         item.value ||
// //         item.original_text ||
// //         item.incorrect ||
// //         item.actual ||
// //         item.phrase ||
// //         "",
// //     }));

// //     const filterSentence = _.filter(
// //       filterValues,
// //       (item) =>
// //         item.type_of_error !== "No error" &&
// //         item.type_of_error !== "No errors" &&
// //         item.type_of_error !== "None" &&
// //         item.type_of_error !== "N/A" &&
// //         item.type_of_error !== "none" &&
// //         item.justification !== "No grammatical errors found." &&
// //         item.justification !== "No error found in the phrase." &&
// //         item.justification !== "" &&
// //         item.justification !== "The sentence is grammatically correct." &&
// //         item.corrective_text !== "" &&
// //         item.value !== "",
// //     );

// //     const finalFilteredValues = filterSentence.filter(
// //       (s) => !ignoredSuggestions.includes(s.corrective_text),
// //     );

// //     if (finalFilteredValues.length === 0) return;

// //     // ✅ FIX: no duplicate sentences
// //     const flatArray = finalFilteredValues
// //       .map((v) => v.phrase)
// //       .filter(Boolean)
// //       .flatMap((sentence) =>
// //         sentence
// //           .replace(/\.+/g, ".")
// //           .split(".")
// //           .map((s) => s.trim())
// //           .filter(Boolean)
// //           .map((s) => (s.endsWith(".") ? s : s + ".")),
// //       );

// //     setNewSentences((prev) => {
// //       const set = new Set(prev);
// //       flatArray.forEach((s) => set.add(s));
// //       return Array.from(set);
// //     });

// //     setSuggestionArray((prev) => {
// //       const merged = [...prev, ...finalFilteredValues];
// //       const seen = new Map();

// //       return merged.filter((obj) => {
// //         const key = getSuggestionKey(obj);
// //         if (seen.has(key)) return false;
// //         seen.set(key, true);
// //         return true;
// //       });
// //     });

// //     setIsSuggestion(true);
// //   };

// //   // const handleFilterValues = (sentence) => {
// //   //   sentence.map((item) => {
// //   //     filterValues.push({
// //   //       corrective_text:
// //   //         item["corrective_text"] || item["corrective_text_phrase"],
// //   //       corrective_text_phrase: item["corrective_text_phrase"] || "",
// //   //       justification: item["justification"] || "",
// //   //       phrase: item["phrase"] || "",
// //   //       type_of_error: item["type_of_error"] || "",
// //   //       value: item["value"],
// //   //       errored_text: item["errored_text"],
// //   //     });
// //   //   });
// //   //   let filterSentence = _.filter(
// //   //     filterValues,
// //   //     (item) =>
// //   //       item["type_of_error"] !== "No error" &&
// //   //       item["type_of_error"] !== "No errors" &&
// //   //       item["type_of_error"] !== "None" &&
// //   //       item["type_of_error"] !== "N/A" &&
// //   //       item["type_of_error"] !== "none" &&
// //   //       item["justification"] !== "No grammatical errors found." &&
// //   //       item["justification"] !== "No error found in the phrase." &&
// //   //       item["justification"] !== "" &&
// //   //       item["justification"] !== "The sentence is grammatically correct." &&
// //   //       item["corrective_text"] !== "",
// //   //   );
// //   //   let finalFilteredValues = filterSentence.filter(
// //   //     (suggestion) => !ignoredSuggestions.includes(suggestion.corrective_text),
// //   //   );
// //   //   const values = finalFilteredValues.map((item) => item.phrase);
// //   //   const correctedSentences = values.map((sentence) =>
// //   //     sentence
// //   //       .replace(/\.+/g, ".")
// //   //       .split(".")
// //   //       .filter((s) => s.trim())
// //   //       .map((s) => {
// //   //         const trimmed = s.trim();
// //   //         return trimmed.endsWith(".") ? trimmed : trimmed + ".";
// //   //       }),
// //   //   );
// //   //   const flatArray = correctedSentences.flat();
// //   //   setNewSentences((prevItems) => [...prevItems, ...flatArray]);
// //   //   if (filterSentence.length == 0) {
// //   //     setSentenceResult([]);
// //   //     setIsSuggestion(false);
// //   //   } else {
// //   //     setSuggestionArray((prevSentences) => {
// //   //       const merged = [...prevSentences, ...finalFilteredValues];

// //   //       const seen = new Map();
// //   //       const uniqueArray = merged.filter((obj) => {
// //   //         if (!seen.has(obj.value)) {
// //   //           seen.set(obj.value, true);
// //   //           return true;
// //   //         }
// //   //         return false;
// //   //       });

// //   //       return uniqueArray;
// //   //     });
// //   //     // if (suggestionArray.length == 0) {
// //   //     //   setSuggestionArray(finalFilteredValues);
// //   //     // } else {
// //   //     //   setSuggestionArray((prevSentences) => {
// //   //     //     const merged = [...prevSentences, ...finalFilteredValues.flat()];
// //   //     //     const seen = new Map();
// //   //     //     return merged.filter((obj) => {
// //   //     //       if (!seen.has(obj.value)) {
// //   //     //         seen.set(obj.value, true);
// //   //     //         return true;
// //   //     //       }
// //   //     //       return false;
// //   //     //     });
// //   //     //   });
// //   //     // }
// //   //     setIsSuggestion(true);
// //   //   }
// //   // };

// //   useEffect(() => {
// //     if (suggestionArray.length > 0) {
// //       suggestionArray.map((item) =>
// //         colorWord(item.value, item.errored_text, "red"),
// //       );
// //       setExpanded(suggestionArray[0].errored_text);
// //       setErrorValue(suggestionArray[0].value);
// //       setTimeout(() => {
// //         highLightWords(suggestionArray[0].value, C.accentLight);
// //       }, 0);

// //       setTimeout(() => {
// //         if (!editor.current) return;
// //         const el = focusEditorOnSuggestion(
// //           suggestionArray[0].errored_text,
// //           suggestionArray[0].value,
// //         );
// //         if (!el) return;
// //         const rect = el.getBoundingClientRect();
// //         setInlinePopup({
// //           visible: true,
// //           x: rect.left + rect.width / 2,
// //           y: rect.top,
// //           suggestion: suggestionArray[0],
// //         });
// //       }, 140);
// //     } else {
// //       setInlinePopup({ visible: false, x: 0, y: 0, suggestion: null });
// //     }
// //   }, [suggestionArray]);

// //   const handleExpand = (param) => {
// //     setErrorValue(param.value);
// //     if (param.value !== errorValue) highLightWords(errorValue, "white");
// //     setExpanded(param.errored_text);
// //     highLightWords(param.value, C.accentLight);

// //     if (editor.current) {
// //       const el = focusEditorOnSuggestion(param.errored_text, param.value);
// //       if (el) {
// //         const rect = el.getBoundingClientRect();
// //         setInlinePopup({
// //           visible: true,
// //           x: rect.left + rect.width / 2,
// //           y: rect.top,
// //           suggestion: param,
// //         });
// //       }
// //     }
// //   };

// //   const ErrorChipSummary = ({ errorCounts, C, R, getErrorConfig }) => {
// //     const [anchorEl, setAnchorEl] = useState(null);
// //     const [visibleCount, setVisibleCount] = useState(null);
// //     const containerRef = useRef(null);
// //     const measureRef = useRef(null); // hidden full-render clone for measuring

// //     const entries = Object.entries(errorCounts);
// //     const open = Boolean(anchorEl);

// //     // ── Core measurement: runs on mount + every resize ──────────────────────
// //     const measure = useCallback(() => {
// //       const container = measureRef.current;
// //       if (!container || entries.length === 0) return;

// //       const chips = Array.from(
// //         container.querySelectorAll("[data-chip-measure]"),
// //       );
// //       if (chips.length === 0) return;

// //       // Get the top offset of the first chip as baseline row-start
// //       const baseTop = chips[0].offsetTop;
// //       let firstRowBottom = baseTop + chips[0].offsetHeight;
// //       let secondRowBottom = null;
// //       let count = 0;

// //       for (const chip of chips) {
// //         const chipTop = chip.offsetTop;
// //         const chipBottom = chipTop + chip.offsetHeight;

// //         if (chipTop <= firstRowBottom + 2) {
// //           // Still in row 1
// //           firstRowBottom = Math.max(firstRowBottom, chipBottom);
// //           count++;
// //         } else if (secondRowBottom === null || chipTop <= secondRowBottom + 2) {
// //           // Row 2 started
// //           if (secondRowBottom === null) secondRowBottom = chipBottom;
// //           secondRowBottom = Math.max(secondRowBottom, chipBottom);
// //           count++;
// //         } else {
// //           // Row 3+ → stop
// //           break;
// //         }
// //       }

// //       setVisibleCount(count);
// //     }, [entries.length]);

// //     // ── ResizeObserver: re-measure whenever container width changes ──────────
// //     useEffect(() => {
// //       const el = measureRef.current;
// //       if (!el) return;

// //       // Initial measure after paint
// //       const raf = requestAnimationFrame(measure);

// //       const ro = new ResizeObserver(() => {
// //         requestAnimationFrame(measure);
// //       });
// //       ro.observe(el);

// //       return () => {
// //         cancelAnimationFrame(raf);
// //         ro.disconnect();
// //       };
// //     }, [measure]);

// //     const visible =
// //       visibleCount !== null ? entries.slice(0, visibleCount) : entries;
// //     const overflow = visibleCount !== null ? entries.slice(visibleCount) : [];
// //     const hasOverflow = overflow.length > 0;

// //     // Group overflow by category for the popup
// //     const overflowGrouped = overflow.reduce((acc, [type, count]) => {
// //       const config = getErrorConfig(type);
// //       const label = config.label;
// //       if (!acc[label]) acc[label] = [];
// //       acc[label].push({ type, count, config });
// //       return acc;
// //     }, {});

// //     return (
// //       <Box sx={{ px: 2, pb: 1.5, pt: 0.5 }}>
// //         {/* ── Hidden measurement layer (renders ALL chips, invisible) ── */}
// //         <Box
// //           ref={measureRef}
// //           sx={{
// //             position: "absolute",
// //             visibility: "hidden",
// //             pointerEvents: "none",
// //             display: "flex",
// //             flexWrap: "wrap",
// //             gap: "6px",
// //             // Match exact width of real container
// //             left: 0,
// //             right: 0,
// //             px: 2,
// //           }}
// //         >
// //           {entries.map(([type, count]) => {
// //             const config = getErrorConfig(type);
// //             return (
// //               <Chip
// //                 key={`measure-${type}`}
// //                 data-chip-measure
// //                 icon={config.icon}
// //                 label={`${type} · ${count}`}
// //                 size="small"
// //                 sx={{ height: 22, fontSize: "0.7rem" }}
// //               />
// //             );
// //           })}
// //         </Box>

// //         {/* ── Visible chips row (only `visible` items + +X more) ── */}
// //         <Box
// //           ref={containerRef}
// //           sx={{
// //             display: "flex",
// //             flexWrap: "wrap",
// //             gap: "6px",
// //             alignItems: "center",
// //           }}
// //         >
// //           {visible.map(([type, count]) => {
// //             const config = getErrorConfig(type);
// //             return (
// //               <Chip
// //                 key={type}
// //                 icon={config.icon}
// //                 label={`${type} · ${count}`}
// //                 size="small"
// //                 sx={{
// //                   height: 22,
// //                   fontSize: "0.7rem",
// //                   fontWeight: 700,
// //                   bgcolor: config.bg,
// //                   color: config.color,
// //                   border: `1px solid ${config.color}30`,
// //                   "& .MuiChip-icon": { color: config.color, ml: 0.5 },
// //                   transition: "all 0.15s ease",
// //                   "&:hover": {
// //                     opacity: 0.85,
// //                     transform: "translateY(-1px)",
// //                     boxShadow: `0 3px 8px ${config.color}22`,
// //                   },
// //                 }}
// //               />
// //             );
// //           })}

// //           {/* +X more trigger chip */}
// //           {hasOverflow && (
// //             <Chip
// //               label={
// //                 <Box sx={{ display: "flex", alignItems: "center", gap: 0.4 }}>
// //                   <span>+{overflow.length} more</span>
// //                   <KeyboardArrowDownIcon
// //                     sx={{
// //                       fontSize: 13,
// //                       transition: "transform 0.2s",
// //                       transform: open ? "rotate(180deg)" : "rotate(0deg)",
// //                     }}
// //                   />
// //                 </Box>
// //               }
// //               size="small"
// //               onClick={(e) => setAnchorEl(e.currentTarget)}
// //               sx={{
// //                 height: 22,
// //                 fontSize: "0.7rem",
// //                 fontWeight: 700,
// //                 bgcolor: open ? C.accent : C.accentLight,
// //                 color: open ? "#fff" : C.accent,
// //                 border: `1.5px solid ${C.accent}40`,
// //                 cursor: "pointer",
// //                 transition: "all 0.2s ease",
// //                 "&:hover": {
// //                   bgcolor: C.accent,
// //                   color: "#fff",
// //                   boxShadow: `0 4px 12px ${C.accent}35`,
// //                   transform: "translateY(-1px)",
// //                 },
// //                 "& .MuiChip-label": { px: 1 },
// //               }}
// //             />
// //           )}
// //         </Box>

// //         {/* ── Modern Overflow Popover ── */}
// //         <Popover
// //           open={open}
// //           anchorEl={anchorEl}
// //           onClose={() => setAnchorEl(null)}
// //           anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
// //           transformOrigin={{ vertical: "top", horizontal: "left" }}
// //           TransitionProps={{ timeout: 200 }}
// //           PaperProps={{
// //             elevation: 0,
// //             sx: {
// //               mt: 0.75,
// //               borderRadius: "16px",
// //               border: `1px solid ${C.border}`,
// //               boxShadow: `0 16px 48px rgba(79,110,247,0.14), 0 4px 16px rgba(0,0,0,0.06)`,
// //               maxWidth: 340,
// //               minWidth: 260,
// //               overflow: "hidden",
// //             },
// //           }}
// //         >
// //           {/* Popup header */}
// //           <Box
// //             sx={{
// //               px: 2,
// //               py: 1.25,
// //               background: `linear-gradient(135deg, ${C.accentLight} 0%, #f0f4ff 100%)`,
// //               borderBottom: `1px solid ${C.border}`,
// //               display: "flex",
// //               alignItems: "center",
// //               justifyContent: "space-between",
// //             }}
// //           >
// //             <Typography
// //               sx={{
// //                 fontSize: "0.72rem",
// //                 fontWeight: 800,
// //                 color: C.accent,
// //                 textTransform: "uppercase",
// //                 letterSpacing: "0.08em",
// //               }}
// //             >
// //               More Issues
// //             </Typography>
// //             <Box
// //               sx={{
// //                 height: 20,
// //                 px: 1,
// //                 borderRadius: "10px",
// //                 bgcolor: C.accent,
// //                 display: "flex",
// //                 alignItems: "center",
// //               }}
// //             >
// //               <Typography
// //                 sx={{ fontSize: "0.68rem", fontWeight: 700, color: "#fff" }}
// //               >
// //                 {overflow.length} types
// //               </Typography>
// //             </Box>
// //           </Box>

// //           {/* Popup body */}
// //           <Box sx={{ p: 1.5, maxHeight: 320, overflowY: "auto" }}>
// //             {Object.entries(overflowGrouped).map(([groupLabel, items], gi) => (
// //               <Box
// //                 key={groupLabel}
// //                 sx={{
// //                   mb:
// //                     gi < Object.entries(overflowGrouped).length - 1 ? 1.25 : 0,
// //                 }}
// //               >
// //                 {/* Group label */}
// //                 <Typography
// //                   sx={{
// //                     fontSize: "0.65rem",
// //                     fontWeight: 700,
// //                     color: C.textMuted,
// //                     textTransform: "uppercase",
// //                     letterSpacing: "0.06em",
// //                     mb: 0.6,
// //                     px: 0.25,
// //                   }}
// //                 >
// //                   {groupLabel}
// //                 </Typography>

// //                 {/* Grid of chips in this group */}
// //                 <Grid container spacing={0.75}>
// //                   {items.map(({ type, count, config }) => (
// //                     <Grid key={type} xs="auto">
// //                       <Chip
// //                         icon={config.icon}
// //                         label={`${type} · ${count}`}
// //                         size="small"
// //                         sx={{
// //                           height: 24,
// //                           fontSize: "0.7rem",
// //                           fontWeight: 700,
// //                           bgcolor: config.bg,
// //                           color: config.color,
// //                           border: `1px solid ${config.color}25`,
// //                           "& .MuiChip-icon": { color: config.color, ml: 0.5 },
// //                           transition: "all 0.15s ease",
// //                           "&:hover": {
// //                             bgcolor: config.color,
// //                             color: "#fff",
// //                             "& .MuiChip-icon": { color: "#fff" },
// //                             transform: "translateY(-1px)",
// //                             boxShadow: `0 4px 10px ${config.color}30`,
// //                           },
// //                         }}
// //                       />
// //                     </Grid>
// //                   ))}
// //                 </Grid>

// //                 {gi < Object.entries(overflowGrouped).length - 1 && (
// //                   <Divider sx={{ mt: 1.25, borderColor: C.border }} />
// //                 )}
// //               </Box>
// //             ))}
// //           </Box>

// //           {/* Popup footer total */}
// //           <Box
// //             sx={{
// //               px: 2,
// //               py: 1,
// //               borderTop: `1px solid ${C.border}`,
// //               bgcolor: "#fafbff",
// //               display: "flex",
// //               justifyContent: "flex-end",
// //             }}
// //           >
// //             <Typography
// //               sx={{ fontSize: "0.68rem", color: C.textMuted, fontWeight: 500 }}
// //             >
// //               {overflow.reduce((sum, [, c]) => sum + c, 0)} total issues in{" "}
// //               {overflow.length} categories
// //             </Typography>
// //           </Box>
// //         </Popover>
// //       </Box>
// //     );
// //   };

// //   // ── count by error type ───────────────────────────────────────────────────
// //   const errorCounts = suggestionArray.reduce((acc, s) => {
// //     const type = getErrorConfig(s.type_of_error).label;
// //     acc[type] = (acc[type] || 0) + 1;
// //     return acc;
// //   }, {});

// //   return (
// //     <Box
// //       sx={{
// //         position: "relative",
// //         minHeight: 0,
// //         height: "100%",
// //         display: "flex",
// //         flexDirection: "column",
// //         overflow: "hidden",
// //       }}
// //     >
// //       <InlineGrammarPopup
// //         popup={inlinePopup}
// //         onClose={() =>
// //           setInlinePopup((prev) => ({
// //             ...prev,
// //             visible: false,
// //             suggestion: null,
// //           }))
// //         }
// //         onReplace={() =>
// //           inlinePopup.suggestion && handleAccept(inlinePopup.suggestion)
// //         }
// //         onIgnore={() =>
// //           inlinePopup.suggestion && handleIgnore(inlinePopup.suggestion)
// //         }
// //         onExplain={() => {
// //           if (!inlinePopup.suggestion) return;
// //           handleExpand(inlinePopup.suggestion);
// //           scrollToAccordion(
// //             inlinePopup.suggestion.errored_text,
// //             inlinePopup.suggestion.value,
// //           );
// //         }}
// //       />

// //       {/* Loading overlay */}
// //       {suggestionLoader && (
// //         <Box
// //           sx={{
// //             position: "absolute",
// //             inset: 0,
// //             bgcolor: "rgba(255,255,255,0.85)",
// //             zIndex: 10,
// //             display: "flex",
// //             flexDirection: "column",
// //             alignItems: "center",
// //             justifyContent: "center",
// //             gap: 1.5,
// //             borderRadius: R.lg,
// //           }}
// //         >
// //           <BeatLoader size={12} color={C.accent} loading />
// //           <Typography
// //             sx={{ fontSize: "0.8rem", color: C.textMuted, fontWeight: 500 }}
// //           >
// //             Analyzing your text…
// //           </Typography>
// //           <LinearProgress
// //             sx={{
// //               width: 120,
// //               height: 3,
// //               borderRadius: 2,
// //               bgcolor: C.accentLight,
// //               "& .MuiLinearProgress-bar": { bgcolor: C.accent },
// //             }}
// //           />
// //         </Box>
// //       )}

// //       {/* Error type summary pills */}
// //       {/* {suggestionArray.length > 0 && (
// //         <Box
// //           sx={{
// //             display: "flex",
// //             flexWrap: "wrap",
// //             gap: 0.75,
// //             px: 2,
// //             pb: 1.5,
// //             pt: 0.5,
// //           }}
// //         >
// //           {Object.entries(errorCounts).map(([type, count]) => {
// //             const config = getErrorConfig(type);
// //             return (
// //               <Chip
// //                 key={type}
// //                 icon={config.icon}
// //                 label={`${type} · ${count}`}
// //                 size="small"
// //                 sx={{
// //                   height: 22,
// //                   fontSize: "0.7rem",
// //                   fontWeight: 700,
// //                   bgcolor: config.bg,
// //                   color: config.color,
// //                   border: `1px solid ${config.color}30`,
// //                   "& .MuiChip-icon": { color: config.color, ml: 0.5 },
// //                 }}
// //               />
// //             );
// //           })}
// //         </Box>
// //       )} */}
// //       {suggestionArray.length > 0 && (
// //         <ErrorChipSummary
// //           errorCounts={errorCounts}
// //           C={C}
// //           R={R}
// //           getErrorConfig={getErrorConfig}
// //         />
// //       )}

// //       {/* Suggestion cards */}
// //       <Box
// //         sx={{
// //           px: 2,
// //           pb: 2,
// //           flex: 1,
// //           minHeight: 0,
// //           overflowY: "auto",
// //           overflowX: "auto",
// //         }}
// //       >
// //         {/* {suggestionArray.length === 0 && !suggestionLoader ? (
// //           <EmptyState />
// //         ) : ( */}
// //         {suggestionLoader || isStreaming ? (
// //           // ✅ SHOW LOADER ONLY
// //           <></> // (you already have overlay loader above)
// //         ) : suggestionArray.length === 0 ? (
// //           <EmptyState />
// //         ) : (
// //           suggestionArray.map((suggestion, i) => (
// //             <div key={i} className="cgsuggestion" ref={accordionRef}>
// //               <SuggestionCard
// //                 suggestion={suggestion}
// //                 expanded={expanded}
// //                 onExpand={handleExpand}
// //                 onAccept={handleAccept}
// //                 onIgnore={handleIgnore}
// //                 mobileView={mobileView}
// //               />
// //             </div>
// //           ))
// //         )}
// //       </Box>
// //     </Box>
// //   );
// // };

// // export default SuggestionComp;

// import React, { useState, useEffect, useRef, useCallback } from "react";
// import _ from "lodash";
// import { ContentState, EditorState, Modifier, SelectionState } from "draft-js";
// import DocumentService from "../../services/document";
// import { strCount } from "../Editor/utilize";
// import { useSelector } from "react-redux";
// import {
//   Accordion,
//   AccordionActions,
//   AccordionDetails,
//   AccordionSummary,
//   Button,
//   IconButton,
//   Typography,
//   Box,
//   Chip,
//   Divider,
//   LinearProgress,
//   Tooltip,
//   Fade,
//   Badge,
// } from "@mui/material";
// import { BeatLoader } from "react-spinners";
// import { css } from "@emotion/react";
// import GrammarIcon from "@mui/icons-material/Spellcheck";
// import StyleIcon from "@mui/icons-material/AutoFixHigh";
// import ClarityIcon from "@mui/icons-material/Visibility";
// import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
// import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import CloseIcon from "@mui/icons-material/Close";
// import Grid from "@mui/material/Unstable_Grid2";
// import Popover from "@mui/material/Popover";
// import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
// import { toast, ToastContainer } from "react-toastify";
// // ─── DESIGN TOKENS ──────────────────────────────────────────────────────────
// const C = {
//   bg: "#f0f2f8",
//   surface: "#ffffff",
//   border: "rgba(99,120,180,0.14)",
//   accent: "#4f6ef7",
//   accentLight: "#cdd3ee",
//   success: "#22c55e",
//   successLight: "#f0fdf4",
//   error: "#ef4444",
//   errorLight: "#fef2f2",
//   warning: "#f59e0b",
//   warningLight: "#fffbeb",
//   purple: "#8b5cf6",
//   purpleLight: "#f5f3ff",
//   textPrimary: "#1a1d2e",
//   textSecondary: "#64748b",
//   textMuted: "#434343",
// };

// const R = { sm: "8px", md: "12px", lg: "16px" };

// // ─── ERROR TYPE CONFIG ────────────────────────────────────────────────────────
// const getErrorConfig = (type = "") => {
//   const t = type.toLowerCase();
//   if (t.includes("grammar") || t.includes("grammatical"))
//     return {
//       color: C.error,
//       bg: C.errorLight,
//       label: "Grammar",
//       icon: <GrammarIcon sx={{ fontSize: 13 }} />,
//     };
//   if (t.includes("spell"))
//     return {
//       color: C.warning,
//       bg: C.warningLight,
//       label: "Spelling",
//       icon: <GrammarIcon sx={{ fontSize: 13 }} />,
//     };
//   if (t.includes("style"))
//     return {
//       color: C.purple,
//       bg: C.purpleLight,
//       label: "Style",
//       icon: <StyleIcon sx={{ fontSize: 13 }} />,
//     };
//   if (t.includes("clarity"))
//     return {
//       color: C.accent,
//       bg: C.accentLight,
//       label: "Clarity",
//       icon: <ClarityIcon sx={{ fontSize: 13 }} />,
//     };
//   return {
//     color: C.textSecondary,
//     bg: "#f8fafc",
//     label: type || "Issue",
//     icon: <SwapHorizIcon sx={{ fontSize: 13 }} />,
//   };
// };

// const override = css`
//   position: absolute;
//   left: 42%;
//   top: 50%;
//   margin: 0 auto;
//   z-index: 9999;
// `;

// // ─── EMPTY STATE ─────────────────────────────────────────────────────────────
// const EmptyState = () => (
//   <Box
//     sx={{
//       display: "flex",
//       flexDirection: "column",
//       alignItems: "center",
//       justifyContent: "center",
//       py: 6,
//       px: 3,
//       gap: 1.5,
//     }}
//   >
//     <Box
//       sx={{
//         width: 56,
//         height: 56,
//         borderRadius: "50%",
//         bgcolor: C.successLight,
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         mb: 0.5,
//       }}
//     >
//       <CheckCircleOutlineIcon sx={{ fontSize: 28, color: C.success }} />
//     </Box>
//     <Typography
//       sx={{ fontWeight: 700, color: C.textPrimary, fontSize: "0.95rem" }}
//     >
//       All good!
//     </Typography>
//     <Typography
//       sx={{
//         color: C.textMuted,
//         fontSize: "0.82rem",
//         textAlign: "center",
//         lineHeight: 1.5,
//       }}
//     >
//       No suggestions found. Your writing looks great.
//     </Typography>
//   </Box>
// );

// const InlineGrammarPopup = ({
//   popup,
//   onClose,
//   onReplace,
//   onIgnore,
//   onExplain,
// }) => {
//   if (!popup?.visible || !popup?.suggestion) return null;

//   return (
//     <Box
//       onMouseDown={(e) => e.preventDefault()}
//       sx={{
//         position: "fixed",
//         top: popup.y,
//         left: popup.x,
//         transform: "translate(-50%, -112%)",
//         zIndex: 9999,
//         minWidth: 300,
//         maxWidth: 360,
//         borderRadius: "18px",
//         background: "rgba(255,255,255,0.96)",
//         border: `1px solid ${C.border}`,
//         boxShadow: "0 20px 55px rgba(91,111,232,0.18)",
//         backdropFilter: "blur(14px)",
//         overflow: "visible",
//         "&::after": {
//           content: '""',
//           position: "absolute",
//           left: "50%",
//           bottom: -7,
//           width: 14,
//           height: 14,
//           background: "rgba(255,255,255,0.96)",
//           borderRight: `1px solid ${C.border}`,
//           borderBottom: `1px solid ${C.border}`,
//           transform: "translateX(-50%) rotate(45deg)",
//         },
//       }}
//     >
//       <Box
//         sx={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "space-between",
//           px: 1.5,
//           pt: 1.05,
//           pb: 0.55,
//           borderBottom: `1px solid ${C.border}`,
//         }}
//       >
//         <Typography
//           sx={{ fontSize: "12px", fontWeight: 700, color: C.textMuted }}
//         >
//           Suggestion:
//         </Typography>
//         <IconButton
//           size="small"
//           onClick={onClose}
//           sx={{
//             width: 28,
//             height: 28,
//             color: C.textMuted,
//             "&:hover": { color: C.error, bgcolor: C.errorLight },
//           }}
//         >
//           <CloseIcon sx={{ fontSize: 15 }} />
//         </IconButton>
//       </Box>

//       <Box
//         sx={{
//           mx: 1.5,
//           my: 0.9,
//           px: 1.2,
//           py: 1,
//           borderRadius: R.md,
//           background: "#f9faff",
//           border: `1px solid ${C.border}`,
//         }}
//       >
//         <Typography
//           sx={{ fontSize: "0.95rem", fontWeight: 500, color: C.textPrimary }}
//         >
//           &ldquo;{popup.suggestion.value || popup.suggestion.errored_text || ""}
//           &rdquo;
//         </Typography>
//       </Box>

//       <Box sx={{ px: 1.5, pb: 1.4, display: "flex", gap: 0.75 }}>
//         <Button
//           onClick={onReplace}
//           startIcon={<SwapHorizIcon sx={{ fontSize: 15 }} />}
//           sx={{
//             flex: 1,
//             borderRadius: "12px",
//             textTransform: "none",
//             fontWeight: 700,
//             fontSize: "12.5px",
//             py: 0.72,
//             color: "#fff",
//             background: `linear-gradient(135deg, ${C.accent} 0%, #6f86ff 100%)`,
//             boxShadow: "0 10px 22px rgba(91,111,232,0.22)",
//             "&:hover": {
//               background: `linear-gradient(135deg, #445ee5 0%, ${C.accent} 100%)`,
//             },
//           }}
//         >
//           Replace
//         </Button>
//         <Button
//           onClick={onIgnore}
//           sx={{
//             flex: 1,
//             borderRadius: "12px",
//             textTransform: "none",
//             fontWeight: 600,
//             fontSize: "12.5px",
//             py: 0.72,
//             color: C.textSecondary,
//             background: C.surface,
//             border: `1px solid ${C.border}`,
//             "&:hover": { background: "#f5f7ff", borderColor: C.accent },
//           }}
//         >
//           Ignore
//         </Button>
//         <Button
//           onClick={onExplain}
//           startIcon={<ClarityIcon sx={{ fontSize: 15 }} />}
//           sx={{
//             flex: 1,
//             borderRadius: "12px",
//             textTransform: "none",
//             fontWeight: 600,
//             fontSize: "12.5px",
//             py: 0.72,
//             color: C.accent,
//             background: C.surface,
//             border: `1px solid ${C.border}`,
//             "&:hover": { background: C.accentLight, borderColor: C.accent },
//           }}
//         >
//           Explain
//         </Button>
//       </Box>
//     </Box>
//   );
// };

// // ─── SUGGESTION CARD ─────────────────────────────────────────────────────────
// const SuggestionCard = ({
//   suggestion,
//   expanded,
//   onExpand,
//   onAccept,
//   onIgnore,
//   mobileView,
// }) => {
//   const config = getErrorConfig(suggestion.type_of_error);

//   return (
//     <Accordion
//       expanded={expanded === suggestion.errored_text}
//       onChange={() => onExpand(suggestion)}
//       id={`accordion-${suggestion.errored_text}`}
//       disableGutters
//       elevation={0}
//       sx={{
//         border: `1.5px solid ${expanded === suggestion.errored_text ? config.color + "40" : C.border}`,
//         borderRadius: `${R.md} !important`,
//         mb: 1.25,
//         overflow: "hidden",
//         transition: "all 0.2s ease",
//         "&:before": { display: "none" },
//         "&.Mui-expanded": {
//           boxShadow: `0 4px 16px ${config.color}18`,
//         },
//       }}
//     >
//       <AccordionSummary
//         expandIcon={
//           <ExpandMoreIcon
//             sx={{
//               fontSize: 18,
//               color:
//                 expanded === suggestion.errored_text
//                   ? config.color
//                   : C.textMuted,
//               transition: "color 0.2s",
//             }}
//           />
//         }
//         sx={{
//           px: 2,
//           py: 0.5,
//           minHeight: 52,
//           bgcolor: expanded === suggestion.errored_text ? config.bg : C.surface,
//           transition: "background-color 0.2s",
//           "&:hover": { bgcolor: config.bg },
//           "& .MuiAccordionSummary-content": {
//             margin: "10px 0",
//             alignItems: "center",
//             gap: 1,
//           },
//         }}
//       >
//         <Box sx={{ flex: 1, minWidth: 0 }}>
//           <Typography
//             sx={{
//               fontWeight: 600,
//               fontSize: "0.83rem",
//               color: config.color,
//               textDecoration: "line-through",
//               textDecorationColor: config.color + "80",
//               letterSpacing: "-0.01em",
//               whiteSpace: "normal",
//               overflowWrap: "break-word",
//             }}
//           >
//             {suggestion.errored_text}
//           </Typography>
//         </Box>
//         <Chip
//           icon={config.icon}
//           label={config.label}
//           size="small"
//           sx={{
//             height: 22,
//             fontSize: "0.7rem",
//             fontWeight: 700,
//             bgcolor: config.bg,
//             color: config.color,
//             border: `1px solid ${config.color}30`,
//             "& .MuiChip-icon": { color: config.color, ml: 0.5 },
//             flexShrink: 0,
//           }}
//         />
//       </AccordionSummary>

//       <AccordionDetails
//         sx={{
//           px: 2,
//           py: 1.5,
//           bgcolor: C.surface,
//           borderTop: `1px solid ${C.border}`,
//         }}
//       >
//         {/* Replace with */}
//         <Box
//           sx={{
//             display: "flex",
//             alignItems: "flex-start",
//             gap: 1,
//             mb: 1.5,
//             p: 1.25,
//             borderRadius: R.sm,
//             bgcolor: C.accentLight,
//             border: `1px solid ${C.accent}25`,
//           }}
//         >
//           <SwapHorizIcon
//             sx={{ fontSize: 16, color: C.accent, mt: 0.15, flexShrink: 0 }}
//           />
//           <Box>
//             <Typography
//               sx={{
//                 fontSize: "0.72rem",
//                 fontWeight: 600,
//                 color: C.textMuted,
//                 mb: 0.25,
//                 textTransform: "uppercase",
//                 letterSpacing: "0.04em",
//               }}
//             >
//               Replace with
//             </Typography>
//             <Typography
//               sx={{ fontSize: "0.85rem", fontWeight: 700, color: C.accent }}
//             >
//               &ldquo;{suggestion.corrective_text}&rdquo;
//             </Typography>
//           </Box>
//         </Box>

//         {/* Justification */}
//         {suggestion.justification && (
//           <Box sx={{ mb: 0.5 }}>
//             <Typography
//               sx={{
//                 fontSize: "0.72rem",
//                 fontWeight: 600,
//                 color: C.textMuted,
//                 mb: 0.5,
//                 textTransform: "uppercase",
//                 letterSpacing: "0.04em",
//               }}
//             >
//               Why
//             </Typography>
//             <Typography
//               sx={{
//                 fontSize: "0.82rem",
//                 color: C.textSecondary,
//                 lineHeight: 1.55,
//               }}
//             >
//               {suggestion.justification}
//             </Typography>
//           </Box>
//         )}
//       </AccordionDetails>

//       <AccordionActions
//         sx={{
//           px: 2,
//           py: 1.25,
//           bgcolor: "#fafbff",
//           borderTop: `1px solid ${C.border}`,
//           gap: 1,
//         }}
//       >
//         <Button
//           size="small"
//           variant="outlined"
//           onClick={() => onIgnore(suggestion)}
//           sx={{
//             borderRadius: R.md,
//             textTransform: "none",
//             fontWeight: 600,
//             fontSize: "0.78rem",
//             flex: 1,
//             borderWidth: 1.5,
//             borderColor: C.error + "60",
//             color: C.error,
//             "&:hover": {
//               borderColor: C.error,
//               bgcolor: C.errorLight,
//             },
//           }}
//         >
//           Ignore
//         </Button>
//         <Button
//           size="small"
//           variant="contained"
//           onClick={() => onAccept(suggestion)}
//           sx={{
//             borderRadius: R.md,
//             textTransform: "none",
//             fontWeight: 600,
//             fontSize: "0.78rem",
//             flex: 1,
//             bgcolor: C.accent,
//             boxShadow: "none",
//             "&:hover": {
//               bgcolor: C.accentDark,
//               boxShadow: "none",
//             },
//           }}
//         >
//           Accept
//         </Button>
//       </AccordionActions>
//     </Accordion>
//   );
// };

// // ────────────────────────────────────────────────────────────────────────────
// // MAIN SuggestionComp
// // ────────────────────────────────────────────────────────────────────────────
// const SuggestionComp = ({
//   mobileView,
//   autoSaveContent,
//   docName,
//   docId,
//   newDocId,
//   folderId,
//   tags,
//   ignoreAllClicked,
//   setIgnoreAllClicked,
//   acceptAllClicked,
//   setAcceptAllClicked,
//   setEditorContentUpload,
//   editorContent,
//   changedSentence,
//   setSentenceResult,
//   setState,
//   setIsFeatureButton,
//   editorState,
//   setEditorState,
//   setIsSuggestion,
//   copiedText,
//   editor,
//   setIsType,
//   ignoredSuggestions,
//   windowWidth,
//   setOldSentences,
//   oldSentences,
//   setNewSentences,
//   newSentences,
//   suggestionLoader,
//   editorValue,
//   isStreaming,
// }) => {
//   // const escapeRegex = (value = "") =>
//   //   value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
//   // const getSuggestionValue = (item = {}) =>
//   //   item.value ||
//   //   item.errored_text ||
//   //   item.original_text ||
//   //   item.incorrect ||
//   //   item.actual ||
//   //   item.phrase ||
//   //   "";
//   // const getSuggestionCorrection = (item = {}) =>
//   //   item.corrective_text ||
//   //   item.corrective_text_phrase ||
//   //   item.corrected_text ||
//   //   item.suggestion ||
//   //   item.expected?.[0] ||
//   //   "";
//   // const getSuggestionMatchText = (item = {}) =>
//   //   item.phrase ||
//   //   item.value ||
//   //   item.errored_text ||
//   //   item.original_text ||
//   //   item.incorrect ||
//   //   item.actual ||
//   //   "";
//   // const getSuggestionReplacementText = (item = {}) =>
//   //   item.corrective_text_phrase ||
//   //   item.corrective_text ||
//   //   item.corrected_text ||
//   //   item.suggestion ||
//   //   item.expected?.[0] ||
//   //   "";
//   // const getSuggestionKey = (item = {}) =>
//   //   `${getSuggestionValue(item)}|${getSuggestionCorrection(item)}`;

//   const escapeRegex = (v = "") => v.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

// const getWrongText = (item = {}) =>
//   item.errored_text || item.value || item.phrase ||
//   item.original_text || item.incorrect || item.actual || "";

// const getCorrectText = (item = {}) =>
//   item.corrective_text || item.corrective_text_phrase ||
//   item.corrected_text || item.suggestion || item.expected?.[0] || "";

// const getSuggestionKey = (item = {}) =>
//   `${getWrongText(item)}|||${getCorrectText(item)}`;

// // Aliases so nothing else breaks
// const getSuggestionValue = getWrongText;
// const getSuggestionCorrection = getCorrectText;
// const getSuggestionMatchText = getWrongText;
// const getSuggestionReplacementText = getCorrectText;

//   const [suggestionArray, setSuggestionArray] = useState([]);
//   const [isColorChange, setIsColorChange] = useState(true);
//   const [clickedWord, setClickedWord] = useState("");
//   const { isFullSize } = useSelector((state) => state?.manageFullSizeEditor);
//   const { isFullScreen } = useSelector((state) => state?.manageFullSizeEditor);
//   const [expanded, setExpanded] = useState();
//   const [errorValue, setErrorValue] = useState("");
//   const [inlinePopup, setInlinePopup] = useState({
//     visible: false,
//     x: 0,
//     y: 0,
//     suggestion: null,
//   });

//   // let filterValues = [];
//   const accordionRef = useRef(null);

//   const [wordsCount, characterCount] = strCount(editorContent.toString());

//   // ── all original logic (unchanged) ──────────────────────────────────────
//   // useEffect(() => {
//   //   if (acceptAllClicked) {
//   //     handleAcceptAll(suggestionArray);
//   //     setAcceptAllClicked(false);
//   //   }
//   // }, [acceptAllClicked]);
//   useEffect(() => {
//   if (!acceptAllClicked) return;

//   const toAccept =
//     suggestionArray.length > 0
//       ? suggestionArray
//       : Array.isArray(changedSentence)
//       ? changedSentence
//       : [];

//   handleAcceptAll(toAccept);
//   setAcceptAllClicked(false);
// }, [acceptAllClicked]);

//   useEffect(() => {
//     if (ignoreAllClicked) handleIgnoreAll(suggestionArray);
//     setIgnoreAllClicked(false);
//   }, [ignoreAllClicked]);

//   useEffect(() => {
//     const handleClick = (event) => {
//       const el = event.target.closest(".highlighted-error");
//       if (!el) return;

//       const selectedText = window.getSelection?.()?.toString()?.trim();
//       if (selectedText) {
//         return;
//       }

//       event.preventDefault();
//       event.stopPropagation();

//       const word = decodeURIComponent(el.dataset.word || "");
//       const displayWord = decodeURIComponent(el.dataset.displayWord || "");
//       const suggestionKey = decodeURIComponent(el.dataset.suggestionKey || "");
//       const match =
//         suggestionArray.find((item) => getSuggestionKey(item) === suggestionKey) ||
//         suggestionArray.find(
//           (item) =>
//             item.errored_text === word ||
//             item.value === displayWord ||
//             item.value === word,
//         ) ||
//         null;
//       const rect = el.getBoundingClientRect();

//       console.log("Clicked:", word, displayWord);
//       if (match) {
//         setInlinePopup({
//           visible: true,
//           x: rect.left + rect.width / 2,
//           y: rect.top,
//           suggestion: match,
//         });
//       }
//       scrollToAccordion(word, displayWord);
//     };

//     document.addEventListener("click", handleClick);
//     return () => {
//       document.removeEventListener("click", handleClick);
//     };
//   }, [suggestionArray]);

//   const handleIgnoreAll = async (suggestions) => {
//     suggestions.forEach(async (sentence) => {
//       let filterSentence = suggestionArray.filter(
//         (item) => item.value !== sentence.value,
//       );
//       setSuggestionArray(filterSentence);
//       if (filterSentence.length === 0) {
//         setSentenceResult([]);
//         setIsSuggestion(false);
//       }
//       colorWord(sentence.value, sentence.errored_text, "black", sentence);
//       highLightWords(sentence.value, "white");
//     });
//     setSentenceResult([]);
//     setIsColorChange(false);
//     setIsSuggestion(false);
//   };

//   // const handleAcceptAll = (suggestions) => {
//   //   if (!editor.current || !Array.isArray(suggestions)) return;

//   //   const root = editor.current;

//   //   suggestions.forEach((sentence) => {
//   //     sentence = {
//   //       ...sentence,
//   //       value: getSuggestionValue(sentence),
//   //       corrective_text: getSuggestionCorrection(sentence),
//   //     };
//   //     const wrongText = getSuggestionMatchText(sentence);
//   //     const correctText = getSuggestionReplacementText(sentence);

//   //     if (!wrongText || !correctText) return;

//   //     const walker = document.createTreeWalker(
//   //         root,
//   //       NodeFilter.SHOW_TEXT,
//   //       null,
//   //       false,
//   //     );

//   //     let node;

//   //     while ((node = walker.nextNode())) {
//   //       const text = node.nodeValue;

//   //       if (!text.toLowerCase().includes(wrongText.toLowerCase())) continue;

//   //       const updatedText = text.replace(
//   //         new RegExp(escapeRegex(wrongText), "gi"),
//   //         correctText,
//   //       );

//   //       node.nodeValue = updatedText;
//   //     }
//   //   });

//   //   // ✅ STEP 2: Clean ALL spans (remove red + background)
//   //   const spans = root.querySelectorAll("span");

//   //   spans.forEach((span) => {
//   //     const textNode = document.createTextNode(span.textContent);
//   //     span.replaceWith(textNode);
//   //   });

//   //   // ✅ STEP 3: Reset states
//   //   setSuggestionArray([]);
//   //   setSentenceResult([]);
//   //   setIsSuggestion(false);
//   //   setIsColorChange(false);

//   //   // ✅ STEP 4: Track updated sentences
//   //   const allCorrections = suggestions.map((s) => getSuggestionCorrection(s));

//   //   setNewSentences((prev) => [...prev, ...allCorrections]);
//   // };

//   // const colorWord = (word, errorWord, color) => {
//   //   if (!editor.current) return;

//   //   let content = editor.current.innerHTML;
//   //   const escapedWord = escapeRegex(word);
//   //   const rawErrorWord = errorWord || "";
//   //   const encodedErrorWord = encodeURIComponent(rawErrorWord);
//   //   const encodedDisplayWord = encodeURIComponent(word || "");
//   //   const escapedRawErrorWord = escapeRegex(rawErrorWord);
//   //   const escapedEncodedErrorWord = escapeRegex(encodedErrorWord);
//   //   const spanRemovalRegex = new RegExp(
//   //     `<span[^>]*?data-word=["'](?:${escapedRawErrorWord}|${escapedEncodedErrorWord})["'][^>]*?>(.*?)<\\/span>`,
//   //     "gi",
//   //   );
//   //   content = content.replace(spanRemovalRegex, "$1");
//   //   const replacement = `<span onclick="window.handleHighlightedWordClick(event,this)" data-word="${encodedErrorWord}" data-display-word="${encodedDisplayWord}" style="color: ${color}; cursor:pointer">${word}</span>`;
//   //   const coloredContent = content.replace(
//   //     new RegExp(`(${escapedWord})(?![^<]*>)`, "gi"),
//   //     replacement,
//   //   );
//   //   editor.current.innerHTML = coloredContent;
//   // };

//   // const handleAcceptAll = (suggestions) => {
//   //   if (!editor.current || !Array.isArray(suggestions)) return;
//   //   const root = editor.current;
//   //   suggestions.forEach((sentence) => {
//   //     const wrongSentence = sentence.phrase;
//   //     const correctSentence = sentence.corrective_text_phrase;

//   //     if (!wrongSentence || !correctSentence) return;

//   //     const walker = document.createTreeWalker(
//   //       root,
//   //       NodeFilter.SHOW_TEXT,
//   //       null,
//   //       false,
//   //     );

//   //     let node;

//   //     while ((node = walker.nextNode())) {
//   //       const text = node.nodeValue;

//   //       if (!text.toLowerCase().includes(wrongSentence.toLowerCase())) continue;

//   //       const updatedText = text.replace(
//   //         new RegExp(escapeRegex(wrongSentence), "gi"),
//   //         correctSentence,
//   //       );

//   //       node.nodeValue = updatedText;
//   //     }
//   //   });

//   //   // 👉 remove all highlight + color spans (clean UI)
//   //   const spans = root.querySelectorAll("span");

//   //   spans.forEach((span) => {
//   //     const textNode = document.createTextNode(span.textContent);
//   //     span.replaceWith(textNode);
//   //   });

//   //   // 👉 update state
//   //   setSentenceResult([]);
//   //   setIsColorChange(false);
//   //   setIsSuggestion(false);
//   //   setSuggestionArray([]);

//   //   // optional
//   //   setNewSentences((prev) => [
//   //     ...prev,
//   //     ...suggestions.map((s) => s.corrective_text_phrase),
//   //   ]);
//   // };

//   // const colorWord = (word, errorWord, color) => {
//   //   if (!editor.current || !word) return;

//   //   const root = editor.current;
//   //   const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);

//   //   let node;
//   //   while ((node = walker.nextNode())) {
//   //     const text = node.nodeValue;

//   //     if (!text.toLowerCase().includes(word.toLowerCase())) continue;

//   //     const parts = text.split(new RegExp(`(${escapeRegex(word)})`, "gi"));
//   //     const fragment = document.createDocumentFragment();

//   //     parts.forEach((part) => {
//   //       if (part.toLowerCase() === word.toLowerCase()) {
//   //         const span = document.createElement("span");
//   //         span.style.color = color;
//   //         span.style.cursor = "pointer";
//   //         span.setAttribute("data-word", errorWord);
//   //         span.setAttribute("data-display-word", word);

//   //         span.onclick = (e) => window.handleHighlightedWordClick(e, span);

//   //         span.textContent = part;
//   //         fragment.appendChild(span);
//   //       } else {
//   //         fragment.appendChild(document.createTextNode(part));
//   //       }
//   //     });

//   //     node.replaceWith(fragment);
//   //   }
//   // };

//   // window.handleHighlightedWordClick = (event, el) => {
//   //   event.preventDefault();
//   //   event.stopPropagation();
//   //   const word = decodeURIComponent(el.dataset.word);
//   //   const clickedDisplayWord = decodeURIComponent(el.dataset.displayWord || "");
//   //   scrollToAccordion(word, clickedDisplayWord);
//   // };

// // const handleAcceptAll = (suggestions) => {
// //   if (!editor.current || !Array.isArray(suggestions) || suggestions.length === 0) return;

// //   const root = editor.current;

// //   suggestions.forEach((item) => {
// //     const wrongValue  = item.value         || item.errored_text || "";
// //     const wrongPhrase = item.errored_text  || item.value        || "";
// //     const correctText = getCorrectText(item);

// //     if (
// //       !wrongValue || !correctText ||
// //       item.type_of_error === "None" ||
// //       item.type_of_error === "No error" ||
// //       item.type_of_error === "none"
// //     ) return;

// //     // Skip no-op corrections (wrong === correct)
// //     if (wrongValue === correctText && wrongPhrase === correctText) return;

// //     // ── Step A: replace inside highlighted spans ────────────────────────
// //     const encodedValue  = encodeURIComponent(wrongValue);
// //     const encodedPhrase = encodeURIComponent(wrongPhrase);

// //     const selectors = [
// //       `span.highlighted-error[data-display-word="${encodedValue}"]`,
// //       `span.highlighted-error[data-display-word="${encodedPhrase}"]`,
// //       `span.highlighted-error[data-word="${encodedValue}"]`,
// //       `span.highlighted-error[data-word="${encodedPhrase}"]`,
// //     ].join(",");

// //     const spans = root.querySelectorAll(selectors);

// //     if (spans.length > 0) {
// //       spans.forEach((span) => {
// //         // Replace span text content with correct text, preserve surrounding
// //         span.replaceWith(document.createTextNode(correctText));
// //       });
// //       return; // span found and replaced — skip text node walk
// //     }

// //     // ── Step B: text node fallback ──────────────────────────────────────
// //     // Use BOTH wrongValue and wrongPhrase as search candidates
// //     const candidates = [...new Set([wrongValue, wrongPhrase].filter(Boolean))];

// //     candidates.forEach((searchText) => {
// //       if (!searchText || searchText === correctText) return;

// //       // CRITICAL: use word boundary \b for short strings (≤3 chars)
// //       // to avoid replacing "i" inside "writing", "5" inside "500", etc.
// //       const isShort = searchText.length <= 3;
// //       const pattern = isShort
// //         ? `\\b${escapeRegex(searchText)}\\b`
// //         : escapeRegex(searchText);

// //       const regex = new RegExp(pattern, "gi");

// //       const walker = document.createTreeWalker(
// //         root, NodeFilter.SHOW_TEXT, null, false
// //       );
// //       const toReplace = [];
// //       let node;
// //       while ((node = walker.nextNode())) {
// //         regex.lastIndex = 0;
// //         if (regex.test(node.nodeValue)) toReplace.push(node);
// //       }

// //       toReplace.forEach((textNode) => {
// //         const newRegex = new RegExp(pattern, "gi");
// //         textNode.nodeValue = textNode.nodeValue.replace(newRegex, correctText);
// //       });
// //     });
// //   });

// //   // Clean up ALL remaining highlighted spans
// //   root.querySelectorAll("span.highlighted-error").forEach((span) => {
// //     span.replaceWith(document.createTextNode(span.textContent));
// //   });
// //   // Clean up any other color spans
// //   root.querySelectorAll("span[style]").forEach((span) => {
// //     span.replaceWith(document.createTextNode(span.textContent));
// //   });
// //   root.normalize();

// //   if (typeof setEditorState === "function") setEditorState(root.innerHTML);

// //   const corrected = suggestions.map((s) => getCorrectText(s)).filter(Boolean);
// //   if (typeof setNewSentences === "function") {
// //     setNewSentences((prev) => [...new Set([...prev, ...corrected])]);
// //   }

// //   setSuggestionArray([]);
// //   setSentenceResult([]);
// //   setIsSuggestion(false);
// //   setIsColorChange(false);
// //   setInlinePopup({ visible: false, x: 0, y: 0, suggestion: null });

// //   toast.success("All suggestions applied");
// // };

// ///this is ok
// // const handleAcceptAll = (suggestions) => {
// //   if (!editor.current || !Array.isArray(suggestions)) return;

// //   // 🚫 Prevent while streaming
// //   if (isStreaming) {
// //     toast.warn("Wait until grammar check completes");
// //     return;
// //   }

// //   // ✅ STEP 1: Get full editor text
// //   let text = editor.current.innerText;

// //   // ✅ STEP 2: Normalize suggestions (USE PHRASE LEVEL)
// //   const cleaned = suggestions
// //     .map((s) => ({
// //       wrong: s.phrase || s.errored_text,
// //       correct: s.corrective_text_phrase || s.corrective_text,
// //       type: s.type_of_error,
// //     }))
// //     .filter(
// //       (s) =>
// //         s.wrong &&
// //         s.correct &&
// //         s.wrong !== s.correct &&
// //         s.type !== "none"
// //     );

// //   // ✅ STEP 3: Remove duplicates
// //   const map = new Map();
// //   cleaned.forEach((s) => {
// //     map.set(s.wrong + "|||" + s.correct, s);
// //   });

// //   const unique = Array.from(map.values());

// //   // ✅ STEP 4: Sort by length (VERY IMPORTANT)
// //   unique.sort((a, b) => b.wrong.length - a.wrong.length);

// //   // ✅ STEP 5: Apply replacements (FULL TEXT ONLY)
// //   unique.forEach(({ wrong, correct }) => {
// //     const escaped = wrong.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
// //     const regex = new RegExp(escaped, "g");
// //     text = text.replace(regex, correct);
// //   });

// //   // ✅ STEP 6: Update editor ONCE
// //   editor.current.innerText = text;

// //   // ✅ STEP 7: Remove highlight spans
// //   const spans = editor.current.querySelectorAll("span");
// //   spans.forEach((span) => {
// //     span.replaceWith(document.createTextNode(span.textContent));
// //   });

// //   // ✅ STEP 8: Reset states
// //   setSuggestionArray([]);
// //   setSentenceResult([]);
// //   setIsSuggestion(false);
// //   setIsColorChange(false);

// //   setNewSentences((prev) => [
// //     ...prev,
// //     ...unique.map((s) => s.correct),
// //   ]);
// // };

// const handleAcceptAll = (suggestions) => {
//   if (!editor.current || !Array.isArray(suggestions)) return;

//   if (isStreaming) {
//     toast.warn("Wait until grammar check completes");
//     return;
//   }

//   let text = editor.current.innerText;

//   // ✅ Helper: smart validation
//   const isValid = (wrong, correct) => {
//     if (!wrong || !correct) return false;

//     // skip exact same (only for phrase level)
//     if (wrong === correct) return false;

//     // ❌ avoid breaking sentence badly
//     if (wrong.length > 20 && correct.length < 3) return false;

//     return true;
//   };

//   // ✅ STEP 1: Normalize
//   const normalized = suggestions.map((s) => ({
//     phraseWrong: s.phrase,
//     phraseCorrect: s.corrective_text_phrase,
//     wordWrong: s.errored_text,
//     wordCorrect: s.corrective_text,
//   }));

//   // ✅ STEP 2: APPLY PHRASE FIXES (IMPORTANT)
//   const phraseFixes = normalized
//     .filter((s) => isValid(s.phraseWrong, s.phraseCorrect))
//     .sort((a, b) => b.phraseWrong.length - a.phraseWrong.length);

//   phraseFixes.forEach(({ phraseWrong, phraseCorrect }) => {
//     const escaped = phraseWrong.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
//     const regex = new RegExp(escaped, "g");

//     if (text.includes(phraseWrong)) {
//       text = text.replace(regex, phraseCorrect);
//     }
//   });

//   // ✅ STEP 3: APPLY WORD FIXES (NO LENGTH RESTRICTION)
//   const wordFixes = normalized
//     .filter(
//       (s) =>
//         s.wordWrong &&
//         s.wordCorrect &&
//         s.wordWrong !== s.wordCorrect
//     )
//     .sort((a, b) => b.wordWrong.length - a.wordWrong.length);

//   wordFixes.forEach(({ wordWrong, wordCorrect }) => {
//     const escaped = wordWrong.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

//     // 🔥 important: handle punctuation like ",,"
//     const isWord = /^[a-zA-Z]+$/.test(wordWrong);

//     const regex = isWord
//       ? new RegExp(`\\b${escaped}\\b`, "g") // word safe
//       : new RegExp(escaped, "g"); // punctuation safe

//     if (text.includes(wordWrong)) {
//       text = text.replace(regex, wordCorrect);
//     }
//   });

//   // ✅ STEP 4: update editor once
//   editor.current.innerText = text;

//   // ✅ STEP 5: remove spans
//   editor.current.querySelectorAll("span").forEach((span) => {
//     span.replaceWith(document.createTextNode(span.textContent));
//   });

//   // ✅ STEP 6: reset state
//   setSuggestionArray([]);
//   setSentenceResult([]);
//   setIsSuggestion(false);
//   setIsColorChange(false);
// };

// // const handleAcceptAll = (suggestions) => {
// //   if (!editor.current || !Array.isArray(suggestions)) return;

// //   // 🚫 Prevent during streaming
// //   if (isStreaming) {
// //     toast.warn("Wait until grammar check completes");
// //     return;
// //   }

// //   let text = editor.current.innerText;

// //   // ✅ Helper: validate replacement safely
// //   const isValidReplacement = (wrong, correct) => {
// //     if (!wrong || !correct) return false;

// //     // skip identical
// //     if (wrong === correct) return false;

// //     const wrongWords = wrong.trim().split(/\s+/).length;
// //     const correctWords = correct.trim().split(/\s+/).length;

// //     // ❌ Avoid collapsing large phrase into tiny fragment
// //     if (wrongWords >= 3 && correctWords < 2) return false;

// //     // ❌ Avoid replacing long sentence with very short text
// //     if (wrong.length > 20 && correct.length < 5) return false;

// //     return true;
// //   };

// //   // ✅ STEP 1: Normalize suggestions
// //   const normalized = suggestions.map((s) => ({
// //     phraseWrong: s.phrase,
// //     phraseCorrect: s.corrective_text_phrase,
// //     wordWrong: s.errored_text,
// //     wordCorrect: s.corrective_text,
// //   }));

// //   // ✅ STEP 2: APPLY PHRASE FIXES FIRST
// //   const phraseFixes = normalized
// //     .filter((s) =>
// //       isValidReplacement(s.phraseWrong, s.phraseCorrect)
// //     )
// //     .sort((a, b) => b.phraseWrong.length - a.phraseWrong.length);

// //   phraseFixes.forEach(({ phraseWrong, phraseCorrect }) => {
// //     const escaped = phraseWrong.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
// //     const regex = new RegExp(escaped, "g");

// //     if (text.includes(phraseWrong)) {
// //       text = text.replace(regex, phraseCorrect);
// //     }
// //   });

// //   // ✅ STEP 3: APPLY WORD FIXES AFTER
// //   const wordFixes = normalized
// //     .filter((s) =>
// //       isValidReplacement(s.wordWrong, s.wordCorrect)
// //     )
// //     .sort((a, b) => b.wordWrong.length - a.wordWrong.length);

// //   wordFixes.forEach(({ wordWrong, wordCorrect }) => {
// //     const escaped = wordWrong.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

// //     // word boundary safe replace
// //     const regex = new RegExp(`\\b${escaped}\\b`, "g");

// //     if (text.includes(wordWrong)) {
// //       text = text.replace(regex, wordCorrect);
// //     }
// //   });

// //   // ✅ STEP 4: Update editor ONCE
// //   editor.current.innerText = text;

// //   // ✅ STEP 5: Remove highlight spans
// //   editor.current.querySelectorAll("span").forEach((span) => {
// //     span.replaceWith(document.createTextNode(span.textContent));
// //   });

// //   // ✅ STEP 6: Reset states
// //   setSuggestionArray([]);
// //   setSentenceResult([]);
// //   setIsSuggestion(false);
// //   setIsColorChange(false);
// // };

//   const colorWord = (word, errorWord, color, suggestion = null) => {
//     if (!editor.current || !word) return;

//     const root = editor.current;
//     const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);

//     let node;
//     while ((node = walker.nextNode())) {
//       const text = node.nodeValue;

//       if (!text.toLowerCase().includes(word.toLowerCase())) continue;

//       const parts = text.split(new RegExp(`(${escapeRegex(word)})`, "gi"));
//       const fragment = document.createDocumentFragment();

//       parts.forEach((part) => {
//         if (part.toLowerCase() === word.toLowerCase()) {
//           const span = document.createElement("span");

//           span.style.color = color;
//           span.style.cursor = "text";
//           span.style.userSelect = "text";
//           span.style.webkitUserSelect = "text";

//           // ✅ IMPORTANT
//           span.dataset.displayWord = encodeURIComponent(word || "");
//           span.dataset.word = encodeURIComponent(errorWord || "");
//           span.dataset.suggestionKey = encodeURIComponent(
//             getSuggestionKey(
//               suggestion || {
//                 value: word,
//                 errored_text: errorWord,
//               },
//             ),
//           );

//           span.className = "highlighted-error"; // 🔥 add class

//           span.textContent = part;

//           fragment.appendChild(span);
//         } else {
//           fragment.appendChild(document.createTextNode(part));
//         }
//       });
//       node.replaceWith(fragment);
//     }
//   };

//   window.handleHighlightedWordClick = (event, el) => {
//     console.log("eventWord_", el.dataset);
//     event.preventDefault();
//     event.stopPropagation();
//     const word = decodeURIComponent(el.dataset.word);
//     const clickedDisplayWord = decodeURIComponent(el.dataset.displayWord || "");
//     scrollToAccordion(word, clickedDisplayWord);
//   };

//   // const highLightWords = (word, color) => {
//   //   if (!editor.current || !word) return;

//   //   let content = editor.current.innerHTML;
//   //   const escapedWord = escapeRegex(word);
//   //   const replacement = `<span style="background-color:${color};">${word}</span>`;
//   //   const coloredContent = content?.replace(
//   //     new RegExp(`(${escapedWord})(?![^<]*>)`, "gi"),
//   //     replacement,
//   //   );
//   //   const selection = window.getSelection();
//   //   selection.removeAllRanges();
//   //   editor.current.innerHTML = coloredContent;
//   // };
//   const lastHighlightedRef = useRef(null);

//   const highLightWords = (word, color) => {
//     if (!editor.current || !word) return;

//     // ✅ remove previous highlight
//     if (lastHighlightedRef.current) {
//       lastHighlightedRef.current.style.backgroundColor = "";
//     }

//     const encodedWord = encodeURIComponent(word);

//     const el = editor.current.querySelector(
//       `span[data-display-word="${encodedWord}"]`,
//     );

//     if (el) {
//       el.style.backgroundColor = color;
//       lastHighlightedRef.current = el; // ✅ store reference
//     }
//   };

//   const focusEditorOnSuggestion = (word, displayword) => {
//     if (!editor.current) return null;

//     const root = editor.current;
//     const candidates = [
//       displayword
//         ? `span[data-display-word="${encodeURIComponent(displayword)}"]`
//         : null,
//       word ? `span[data-word="${encodeURIComponent(word)}"]` : null,
//       word ? `span[data-display-word="${encodeURIComponent(word)}"]` : null,
//     ].filter(Boolean);

//     let target = null;

//     for (const selector of candidates) {
//       target = root.querySelector(selector);
//       if (target) break;
//     }

//     if (!target && displayword) {
//       const spans = Array.from(root.querySelectorAll(".highlighted-error"));
//       target =
//         spans.find(
//           (span) =>
//             decodeURIComponent(span.dataset.displayWord || "") === displayword,
//         ) ||
//         spans.find(
//           (span) => decodeURIComponent(span.dataset.word || "") === word,
//         ) ||
//         null;
//     }

//     if (!target) return null;

//     target.scrollIntoView({
//       behavior: "smooth",
//       block: "center",
//       inline: "nearest",
//     });

//     const range = document.createRange();
//     range.selectNodeContents(target);

//     const selection = window.getSelection();
//     if (selection) {
//       selection.removeAllRanges();
//       selection.addRange(range);
//     }

//     root.focus();
//     return target;
//   };

//   const scrollToAccordion = (word, displayword) => {
//     const accordionItems = document.querySelectorAll(
//       `.cgsuggestion [id^="accordion-"]`,
//     );
//     let foundItem = null;
//     accordionItems.forEach((item) => {
//       const erroredText = item.id.replace("accordion-", "");
//       if (erroredText === word && !foundItem) foundItem = item;
//     });
//     if (foundItem) {
//       foundItem.scrollIntoView({ behavior: "smooth", block: "center" });
//       const accordionSummary = foundItem.querySelector(
//         ".MuiAccordionSummary-root",
//       );
//       if (accordionSummary) {
//         accordionSummary.style.backgroundColor = "#e6f7ff";
//         setTimeout(() => {
//           accordionSummary.style.backgroundColor = "";
//         }, 1000);
//       }
//       if (expanded !== word) {
//         setExpanded(word);
//         highLightWords(displayword, C.accentLight);
//       }
//     }

//     focusEditorOnSuggestion(word, displayword);
//   };

//   // const handleAccept = (sentence) => {
//   //   console.log("Accept_Click_", sentence);
//   //   if (!editor.current) return;
//   //   const wrongSentence = sentence.phrase;
//   //   const correctSentence = sentence.corrective_text_phrase;
//   //   const root = editor.current;
//   //   const text = root.innerText;
//   //   const escaped = escapeRegex(wrongSentence || "");
//   //   const updatedText = text.replace(
//   //     new RegExp(escaped, "gi"),
//   //     correctSentence,
//   //   );
//   //   root.innerHTML = updatedText;
//   //   const filterSentence = suggestionArray.filter(
//   //     (item) => item.corrective_text !== sentence.corrective_text,
//   //   );
//   //   if (filterSentence.length === 0) {
//   //     setSentenceResult([]);
//   //     setIsColorChange(false);
//   //     setIsSuggestion(false);
//   //   }
//   //   setSuggestionArray(filterSentence);
//   //   setNewSentences((prev) => [...prev, correctSentence]);
//   // };

//   // const handleAccept = (sentence) => {
//   //   if (!editor.current) return;

//   //   const correctText = sentence.corrective_text_phrase;
//   //   const root = editor.current;

//   //   // 👉 find EXACT clicked/highlighted element
//   //   const highlighted = root.querySelector(
//   //     'span[style*="background-color"]'
//   //   );

//   //   if (!highlighted) {
//   //     console.log("❌ No highlighted element found");
//   //     return;
//   //   }

//   //   // 👉 IMPORTANT: replace WHOLE phrase safely
//   //   const range = document.createRange();
//   //   range.selectNode(highlighted);

//   //   // 👉 replace with correct phrase
//   //   range.deleteContents();
//   //   range.insertNode(document.createTextNode(correctText));

//   //   // 👉 cleanup: remove ALL spans (no duplicate, no red)
//   //   const spans = root.querySelectorAll("span");
//   //   spans.forEach((span) => {
//   //     span.replaceWith(document.createTextNode(span.textContent));
//   //   });

//   //   // 👉 update state
//   //   const filterSentence = suggestionArray.filter(
//   //     (item) => item.corrective_text !== sentence.corrective_text
//   //   );

//   //   if (filterSentence.length === 0) {
//   //     setSentenceResult([]);
//   //     setIsColorChange(false);
//   //     setIsSuggestion(false);
//   //   }

//   //   setSuggestionArray(filterSentence);
//   //   setNewSentences((prev) => [...prev, correctText]);
//   // };

//   // const handleAccept = (sentence) => {
//   //   if (!editor.current) return;

//   //   sentence = {
//   //     ...sentence,
//   //     value: getSuggestionValue(sentence),
//   //     corrective_text: getSuggestionCorrection(sentence),
//   //   };

//   //   const wrongText = getSuggestionMatchText(sentence);
//   //   const correctText = getSuggestionReplacementText(sentence);

//   //   const root = editor.current;

//   //   // ✅ STEP 1: Replace only text nodes (preserve HTML)
//   //   const walker = document.createTreeWalker(
//   //     root,
//   //     NodeFilter.SHOW_TEXT,
//   //     null,
//   //     false,
//   //   );

//   //   let node;

//   //   while ((node = walker.nextNode())) {
//   //     const text = node.nodeValue;

//   //     if (!text.toLowerCase().includes(wrongText.toLowerCase())) continue;

//   //     const updatedText = text.replace(
//   //       new RegExp(escapeRegex(wrongText), "gi"),
//   //       correctText,
//   //     );

//   //     node.nodeValue = updatedText;
//   //   }

//   //   // ✅ STEP 2: Remove ONLY red color spans (clean UI)
//   //   const spans = root.querySelectorAll("span");

//   //   spans.forEach((span) => {
//   //     // remove background highlight
//   //     span.style.backgroundColor = "";

//   //     // remove red color
//   //     span.style.color = "";

//   //     // 👉 OPTIONAL (recommended): remove span completely
//   //     const textNode = document.createTextNode(span.textContent);
//   //     span.replaceWith(textNode);
//   //   });

//   //   // ✅ STEP 3: Update suggestion list
//   //   const filterSentence = suggestionArray.filter(
//   //     (item) => getSuggestionKey(item) !== getSuggestionKey(sentence),
//   //   );

//   //   if (filterSentence.length === 0) {
//   //     setSentenceResult([]);
//   //     setIsColorChange(false);
//   //     setIsSuggestion(false);
//   //   }

//   //   setSuggestionArray(filterSentence);
//   //   setInlinePopup((prev) => ({
//   //     ...prev,
//   //     visible: false,
//   //     suggestion:
//   //       getSuggestionKey(prev?.suggestion || {}) === getSuggestionKey(sentence)
//   //         ? null
//   //         : prev.suggestion,
//   //   }));

//   //   // ✅ STEP 4: Track corrected text
//   //   setNewSentences((prev) => [...prev, correctText]);
//   // };

// const handleAccept = (sentence) => {
//   if (!editor.current) return;

//   const wrongValue  = sentence.value        || sentence.errored_text || "";
//   const wrongPhrase = sentence.errored_text || sentence.value        || "";
//   const correctText = getCorrectText(sentence);

//   if (
//     !correctText ||
//     wrongValue === correctText ||
//     sentence.type_of_error === "None" ||
//     sentence.type_of_error === "No error" ||
//     sentence.type_of_error === "none"
//   ) {
//     const filtered = suggestionArray.filter(
//       (item) => getSuggestionKey(item) !== getSuggestionKey(sentence)
//     );
//     setSuggestionArray(filtered);
//     if (filtered.length === 0) { setSentenceResult([]); setIsSuggestion(false); }
//     return;
//   }

//   const root = editor.current;

//   // Step A — replace inside span
//   const encodedValue  = encodeURIComponent(wrongValue);
//   const encodedPhrase = encodeURIComponent(wrongPhrase);

//   const selectors = [
//     `span.highlighted-error[data-display-word="${encodedValue}"]`,
//     `span.highlighted-error[data-display-word="${encodedPhrase}"]`,
//     `span.highlighted-error[data-word="${encodedValue}"]`,
//     `span.highlighted-error[data-word="${encodedPhrase}"]`,
//   ].join(",");

//   const spans = root.querySelectorAll(selectors);

//   if (spans.length > 0) {
//     spans.forEach((span) => {
//       span.replaceWith(document.createTextNode(correctText));
//     });
//   } else {
//     // Step B — text node fallback with word boundary protection
//     const candidates = [...new Set([wrongValue, wrongPhrase].filter(Boolean))];

//     candidates.forEach((searchText) => {
//       if (!searchText || searchText === correctText) return;

//       const isShort = searchText.length <= 3;
//       const pattern = isShort
//         ? `\\b${escapeRegex(searchText)}\\b`
//         : escapeRegex(searchText);

//       const regex = new RegExp(pattern, "gi");
//       const walker = document.createTreeWalker(
//         root, NodeFilter.SHOW_TEXT, null, false
//       );
//       const toReplace = [];
//       let node;
//       while ((node = walker.nextNode())) {
//         regex.lastIndex = 0;
//         if (regex.test(node.nodeValue)) toReplace.push(node);
//       }
//       toReplace.forEach((n) => {
//         n.nodeValue = n.nodeValue.replace(new RegExp(pattern, "gi"), correctText);
//       });
//     });
//   }

//   root.querySelectorAll("span.highlighted-error").forEach((span) => {
//     span.replaceWith(document.createTextNode(span.textContent));
//   });
//   root.querySelectorAll("span[style]").forEach((span) => {
//     span.replaceWith(document.createTextNode(span.textContent));
//   });
//   root.normalize();

//   if (typeof setEditorState === "function") setEditorState(root.innerHTML);

//   const filtered = suggestionArray.filter(
//     (item) => getSuggestionKey(item) !== getSuggestionKey(sentence)
//   );
//   setSuggestionArray(filtered);

//   if (filtered.length === 0) {
//     setSentenceResult([]);
//     setIsColorChange(false);
//     setIsSuggestion(false);
//   }

//   setInlinePopup((prev) => ({
//     ...prev,
//     visible: false,
//     suggestion:
//       getSuggestionKey(prev?.suggestion || {}) === getSuggestionKey(sentence)
//         ? null : prev.suggestion,
//   }));

//   if (typeof setNewSentences === "function") {
//     setNewSentences((prev) => [...prev, correctText]);
//   }
// };

//   const handleIgnore = async (sentence) => {
//     let filterSentence = _.filter(
//       suggestionArray,
//       (item) => item.value !== sentence.value,
//     );
//     if (filterSentence.length == 0) {
//       setSentenceResult([]);
//       setIsSuggestion(false);
//     }
//     colorWord(sentence.value, sentence.errored_text, "black", sentence);
//     highLightWords(sentence.value, "white");
//     setSuggestionArray(filterSentence);
//     setInlinePopup((prev) => ({
//       ...prev,
//       visible: false,
//       suggestion:
//         prev?.suggestion?.value === sentence.value ? null : prev.suggestion,
//     }));
//   };

//   // useEffect(() => {
//   //   if (changedSentence?.length > 0) handleFilterValues(changedSentence);
//   // }, [changedSentence]);

//   const lastProcessedRef = useRef(0);

//   useEffect(() => {
//     if (!Array.isArray(changedSentence)) return;

//     if (changedSentence.length === 0) {
//       setSuggestionArray([]);
//       lastProcessedRef.current = 0;
//       return;
//     }

//     const fresh = changedSentence.slice(lastProcessedRef.current);

//     if (fresh.length > 0) {
//       handleFilterValues(fresh);
//       lastProcessedRef.current = changedSentence.length;
//     }
//   }, [changedSentence]);

//   const handleFilterValues = (sentence) => {
//     const filterValues = sentence.map((item) => ({
//       corrective_text:
//         item.corrective_text ||
//         item.corrective_text_phrase ||
//         item.corrected_text ||
//         item.suggestion ||
//         item.expected?.[0] ||
//         "",
//       corrective_text_phrase:
//         item.corrective_text_phrase || item.corrected_text || "",
//       justification: item.justification || "",
//       phrase: item.phrase || "",
//       type_of_error: item.type_of_error || "",
//       value:
//         item.value ||
//         item.errored_text ||
//         item.original_text ||
//         item.incorrect ||
//         item.actual ||
//         item.phrase ||
//         "",
//       errored_text:
//         item.errored_text ||
//         item.value ||
//         item.original_text ||
//         item.incorrect ||
//         item.actual ||
//         item.phrase ||
//         "",
//     }));

//     const filterSentence = _.filter(
//       filterValues,
//       (item) =>
//         item.type_of_error !== "No error" &&
//         item.type_of_error !== "No errors" &&
//         item.type_of_error !== "None" &&
//         item.type_of_error !== "N/A" &&
//         item.type_of_error !== "none" &&
//         item.justification !== "No grammatical errors found." &&
//         item.justification !== "No error found in the phrase." &&
//         item.justification !== "" &&
//         item.justification !== "The sentence is grammatically correct." &&
//         item.corrective_text !== "" &&
//         item.value !== "",
//     );

//     const finalFilteredValues = filterSentence.filter(
//       (s) => !ignoredSuggestions.includes(s.corrective_text),
//     );

//     if (finalFilteredValues.length === 0) return;

//     // ✅ FIX: no duplicate sentences
//     const flatArray = finalFilteredValues
//       .map((v) => v.phrase)
//       .filter(Boolean)
//       .flatMap((sentence) =>
//         sentence
//           .replace(/\.+/g, ".")
//           .split(".")
//           .map((s) => s.trim())
//           .filter(Boolean)
//           .map((s) => (s.endsWith(".") ? s : s + ".")),
//       );

//     setNewSentences((prev) => {
//       const set = new Set(prev);
//       flatArray.forEach((s) => set.add(s));
//       return Array.from(set);
//     });

//     setSuggestionArray((prev) => {
//       const merged = [...prev, ...finalFilteredValues];
//       const seen = new Map();

//       return merged.filter((obj) => {
//         const key = getSuggestionKey(obj);
//         if (seen.has(key)) return false;
//         seen.set(key, true);
//         return true;
//       });
//     });

//     setIsSuggestion(true);
//   };

//   // const handleFilterValues = (sentence) => {
//   //   sentence.map((item) => {
//   //     filterValues.push({
//   //       corrective_text:
//   //         item["corrective_text"] || item["corrective_text_phrase"],
//   //       corrective_text_phrase: item["corrective_text_phrase"] || "",
//   //       justification: item["justification"] || "",
//   //       phrase: item["phrase"] || "",
//   //       type_of_error: item["type_of_error"] || "",
//   //       value: item["value"],
//   //       errored_text: item["errored_text"],
//   //     });
//   //   });
//   //   let filterSentence = _.filter(
//   //     filterValues,
//   //     (item) =>
//   //       item["type_of_error"] !== "No error" &&
//   //       item["type_of_error"] !== "No errors" &&
//   //       item["type_of_error"] !== "None" &&
//   //       item["type_of_error"] !== "N/A" &&
//   //       item["type_of_error"] !== "none" &&
//   //       item["justification"] !== "No grammatical errors found." &&
//   //       item["justification"] !== "No error found in the phrase." &&
//   //       item["justification"] !== "" &&
//   //       item["justification"] !== "The sentence is grammatically correct." &&
//   //       item["corrective_text"] !== "",
//   //   );
//   //   let finalFilteredValues = filterSentence.filter(
//   //     (suggestion) => !ignoredSuggestions.includes(suggestion.corrective_text),
//   //   );
//   //   const values = finalFilteredValues.map((item) => item.phrase);
//   //   const correctedSentences = values.map((sentence) =>
//   //     sentence
//   //       .replace(/\.+/g, ".")
//   //       .split(".")
//   //       .filter((s) => s.trim())
//   //       .map((s) => {
//   //         const trimmed = s.trim();
//   //         return trimmed.endsWith(".") ? trimmed : trimmed + ".";
//   //       }),
//   //   );
//   //   const flatArray = correctedSentences.flat();
//   //   setNewSentences((prevItems) => [...prevItems, ...flatArray]);
//   //   if (filterSentence.length == 0) {
//   //     setSentenceResult([]);
//   //     setIsSuggestion(false);
//   //   } else {
//   //     setSuggestionArray((prevSentences) => {
//   //       const merged = [...prevSentences, ...finalFilteredValues];

//   //       const seen = new Map();
//   //       const uniqueArray = merged.filter((obj) => {
//   //         if (!seen.has(obj.value)) {
//   //           seen.set(obj.value, true);
//   //           return true;
//   //         }
//   //         return false;
//   //       });

//   //       return uniqueArray;
//   //     });
//   //     // if (suggestionArray.length == 0) {
//   //     //   setSuggestionArray(finalFilteredValues);
//   //     // } else {
//   //     //   setSuggestionArray((prevSentences) => {
//   //     //     const merged = [...prevSentences, ...finalFilteredValues.flat()];
//   //     //     const seen = new Map();
//   //     //     return merged.filter((obj) => {
//   //     //       if (!seen.has(obj.value)) {
//   //     //         seen.set(obj.value, true);
//   //     //         return true;
//   //     //       }
//   //     //       return false;
//   //     //     });
//   //     //   });
//   //     // }
//   //     setIsSuggestion(true);
//   //   }
//   // };

//   useEffect(() => {
//     if (suggestionArray.length > 0) {
//       suggestionArray.map((item) =>
//         colorWord(item.value, item.errored_text, "red", item),
//       );
//       setExpanded(suggestionArray[0].errored_text);
//       setErrorValue(suggestionArray[0].value);
//       setTimeout(() => {
//         highLightWords(suggestionArray[0].value, C.accentLight);
//       }, 0);

//       setTimeout(() => {
//         if (!editor.current) return;
//         const el = focusEditorOnSuggestion(
//           suggestionArray[0].errored_text,
//           suggestionArray[0].value,
//         );
//         if (!el) return;
//         const rect = el.getBoundingClientRect();
//         setInlinePopup({
//           visible: true,
//           x: rect.left + rect.width / 2,
//           y: rect.top,
//           suggestion: suggestionArray[0],
//         });
//       }, 140);
//     } else {
//       setInlinePopup({ visible: false, x: 0, y: 0, suggestion: null });
//     }
//   }, [suggestionArray]);

//   const handleExpand = (param) => {
//     setErrorValue(param.value);
//     if (param.value !== errorValue) highLightWords(errorValue, "white");
//     setExpanded(param.errored_text);
//     highLightWords(param.value, C.accentLight);

//     if (editor.current) {
//       const el = focusEditorOnSuggestion(param.errored_text, param.value);
//       if (el) {
//         const rect = el.getBoundingClientRect();
//         setInlinePopup({
//           visible: true,
//           x: rect.left + rect.width / 2,
//           y: rect.top,
//           suggestion: param,
//         });
//       }
//     }
//   };

//   const ErrorChipSummary = ({ errorCounts, C, R, getErrorConfig }) => {
//     const [anchorEl, setAnchorEl] = useState(null);
//     const [visibleCount, setVisibleCount] = useState(null);
//     const containerRef = useRef(null);
//     const measureRef = useRef(null); // hidden full-render clone for measuring

//     const entries = Object.entries(errorCounts);
//     const open = Boolean(anchorEl);

//     // ── Core measurement: runs on mount + every resize ──────────────────────
//     const measure = useCallback(() => {
//       const container = measureRef.current;
//       if (!container || entries.length === 0) return;

//       const chips = Array.from(
//         container.querySelectorAll("[data-chip-measure]"),
//       );
//       if (chips.length === 0) return;

//       // Get the top offset of the first chip as baseline row-start
//       const baseTop = chips[0].offsetTop;
//       let firstRowBottom = baseTop + chips[0].offsetHeight;
//       let secondRowBottom = null;
//       let count = 0;

//       for (const chip of chips) {
//         const chipTop = chip.offsetTop;
//         const chipBottom = chipTop + chip.offsetHeight;

//         if (chipTop <= firstRowBottom + 2) {
//           // Still in row 1
//           firstRowBottom = Math.max(firstRowBottom, chipBottom);
//           count++;
//         } else if (secondRowBottom === null || chipTop <= secondRowBottom + 2) {
//           // Row 2 started
//           if (secondRowBottom === null) secondRowBottom = chipBottom;
//           secondRowBottom = Math.max(secondRowBottom, chipBottom);
//           count++;
//         } else {
//           // Row 3+ → stop
//           break;
//         }
//       }

//       setVisibleCount(count);
//     }, [entries.length]);

//     // ── ResizeObserver: re-measure whenever container width changes ──────────
//     useEffect(() => {
//       const el = measureRef.current;
//       if (!el) return;

//       // Initial measure after paint
//       const raf = requestAnimationFrame(measure);

//       const ro = new ResizeObserver(() => {
//         requestAnimationFrame(measure);
//       });
//       ro.observe(el);

//       return () => {
//         cancelAnimationFrame(raf);
//         ro.disconnect();
//       };
//     }, [measure]);

//     const visible =
//       visibleCount !== null ? entries.slice(0, visibleCount) : entries;
//     const overflow = visibleCount !== null ? entries.slice(visibleCount) : [];
//     const hasOverflow = overflow.length > 0;

//     // Group overflow by category for the popup
//     const overflowGrouped = overflow.reduce((acc, [type, count]) => {
//       const config = getErrorConfig(type);
//       const label = config.label;
//       if (!acc[label]) acc[label] = [];
//       acc[label].push({ type, count, config });
//       return acc;
//     }, {});

//     return (
//       <Box sx={{ px: 2, pb: 1.5, pt: 0.5 }}>
//         {/* ── Hidden measurement layer (renders ALL chips, invisible) ── */}
//         <Box
//           ref={measureRef}
//           sx={{
//             position: "absolute",
//             visibility: "hidden",
//             pointerEvents: "none",
//             display: "flex",
//             flexWrap: "wrap",
//             gap: "6px",
//             // Match exact width of real container
//             left: 0,
//             right: 0,
//             px: 2,
//           }}
//         >
//           {entries.map(([type, count]) => {
//             const config = getErrorConfig(type);
//             return (
//               <Chip
//                 key={`measure-${type}`}
//                 data-chip-measure
//                 icon={config.icon}
//                 label={`${type} · ${count}`}
//                 size="small"
//                 sx={{ height: 22, fontSize: "0.7rem" }}
//               />
//             );
//           })}
//         </Box>

//         {/* ── Visible chips row (only `visible` items + +X more) ── */}
//         <Box
//           ref={containerRef}
//           sx={{
//             display: "flex",
//             flexWrap: "wrap",
//             gap: "6px",
//             alignItems: "center",
//           }}
//         >
//           {visible.map(([type, count]) => {
//             const config = getErrorConfig(type);
//             return (
//               <Chip
//                 key={type}
//                 icon={config.icon}
//                 label={`${type} · ${count}`}
//                 size="small"
//                 sx={{
//                   height: 22,
//                   fontSize: "0.7rem",
//                   fontWeight: 700,
//                   bgcolor: config.bg,
//                   color: config.color,
//                   border: `1px solid ${config.color}30`,
//                   "& .MuiChip-icon": { color: config.color, ml: 0.5 },
//                   transition: "all 0.15s ease",
//                   "&:hover": {
//                     opacity: 0.85,
//                     transform: "translateY(-1px)",
//                     boxShadow: `0 3px 8px ${config.color}22`,
//                   },
//                 }}
//               />
//             );
//           })}

//           {/* +X more trigger chip */}
//           {hasOverflow && (
//             <Chip
//               label={
//                 <Box sx={{ display: "flex", alignItems: "center", gap: 0.4 }}>
//                   <span>+{overflow.length} more</span>
//                   <KeyboardArrowDownIcon
//                     sx={{
//                       fontSize: 13,
//                       transition: "transform 0.2s",
//                       transform: open ? "rotate(180deg)" : "rotate(0deg)",
//                     }}
//                   />
//                 </Box>
//               }
//               size="small"
//               onClick={(e) => setAnchorEl(e.currentTarget)}
//               sx={{
//                 height: 22,
//                 fontSize: "0.7rem",
//                 fontWeight: 700,
//                 bgcolor: open ? C.accent : C.accentLight,
//                 color: open ? "#fff" : C.accent,
//                 border: `1.5px solid ${C.accent}40`,
//                 cursor: "pointer",
//                 transition: "all 0.2s ease",
//                 "&:hover": {
//                   bgcolor: C.accent,
//                   color: "#fff",
//                   boxShadow: `0 4px 12px ${C.accent}35`,
//                   transform: "translateY(-1px)",
//                 },
//                 "& .MuiChip-label": { px: 1 },
//               }}
//             />
//           )}
//         </Box>

//         {/* ── Modern Overflow Popover ── */}
//         <Popover
//           open={open}
//           anchorEl={anchorEl}
//           onClose={() => setAnchorEl(null)}
//           anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
//           transformOrigin={{ vertical: "top", horizontal: "left" }}
//           TransitionProps={{ timeout: 200 }}
//           PaperProps={{
//             elevation: 0,
//             sx: {
//               mt: 0.75,
//               borderRadius: "16px",
//               border: `1px solid ${C.border}`,
//               boxShadow: `0 16px 48px rgba(79,110,247,0.14), 0 4px 16px rgba(0,0,0,0.06)`,
//               maxWidth: 340,
//               minWidth: 260,
//               overflow: "hidden",
//             },
//           }}
//         >
//           {/* Popup header */}
//           <Box
//             sx={{
//               px: 2,
//               py: 1.25,
//               background: `linear-gradient(135deg, ${C.accentLight} 0%, #f0f4ff 100%)`,
//               borderBottom: `1px solid ${C.border}`,
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//             }}
//           >
//             <Typography
//               sx={{
//                 fontSize: "0.72rem",
//                 fontWeight: 800,
//                 color: C.accent,
//                 textTransform: "uppercase",
//                 letterSpacing: "0.08em",
//               }}
//             >
//               More Issues
//             </Typography>
//             <Box
//               sx={{
//                 height: 20,
//                 px: 1,
//                 borderRadius: "10px",
//                 bgcolor: C.accent,
//                 display: "flex",
//                 alignItems: "center",
//               }}
//             >
//               <Typography
//                 sx={{ fontSize: "0.68rem", fontWeight: 700, color: "#fff" }}
//               >
//                 {overflow.length} types
//               </Typography>
//             </Box>
//           </Box>

//           {/* Popup body */}
//           <Box sx={{ p: 1.5, maxHeight: 320, overflowY: "auto" }}>
//             {Object.entries(overflowGrouped).map(([groupLabel, items], gi) => (
//               <Box
//                 key={groupLabel}
//                 sx={{
//                   mb:
//                     gi < Object.entries(overflowGrouped).length - 1 ? 1.25 : 0,
//                 }}
//               >
//                 {/* Group label */}
//                 <Typography
//                   sx={{
//                     fontSize: "0.65rem",
//                     fontWeight: 700,
//                     color: C.textMuted,
//                     textTransform: "uppercase",
//                     letterSpacing: "0.06em",
//                     mb: 0.6,
//                     px: 0.25,
//                   }}
//                 >
//                   {groupLabel}
//                 </Typography>

//                 {/* Grid of chips in this group */}
//                 <Grid container spacing={0.75}>
//                   {items.map(({ type, count, config }) => (
//                     <Grid key={type} xs="auto">
//                       <Chip
//                         icon={config.icon}
//                         label={`${type} · ${count}`}
//                         size="small"
//                         sx={{
//                           height: 24,
//                           fontSize: "0.7rem",
//                           fontWeight: 700,
//                           bgcolor: config.bg,
//                           color: config.color,
//                           border: `1px solid ${config.color}25`,
//                           "& .MuiChip-icon": { color: config.color, ml: 0.5 },
//                           transition: "all 0.15s ease",
//                           "&:hover": {
//                             bgcolor: config.color,
//                             color: "#fff",
//                             "& .MuiChip-icon": { color: "#fff" },
//                             transform: "translateY(-1px)",
//                             boxShadow: `0 4px 10px ${config.color}30`,
//                           },
//                         }}
//                       />
//                     </Grid>
//                   ))}
//                 </Grid>

//                 {gi < Object.entries(overflowGrouped).length - 1 && (
//                   <Divider sx={{ mt: 1.25, borderColor: C.border }} />
//                 )}
//               </Box>
//             ))}
//           </Box>

//           {/* Popup footer total */}
//           <Box
//             sx={{
//               px: 2,
//               py: 1,
//               borderTop: `1px solid ${C.border}`,
//               bgcolor: "#fafbff",
//               display: "flex",
//               justifyContent: "flex-end",
//             }}
//           >
//             <Typography
//               sx={{ fontSize: "0.68rem", color: C.textMuted, fontWeight: 500 }}
//             >
//               {overflow.reduce((sum, [, c]) => sum + c, 0)} total issues in{" "}
//               {overflow.length} categories
//             </Typography>
//           </Box>
//         </Popover>
//       </Box>
//     );
//   };

//   // ── count by error type ───────────────────────────────────────────────────
//   const errorCounts = suggestionArray.reduce((acc, s) => {
//     const type = getErrorConfig(s.type_of_error).label;
//     acc[type] = (acc[type] || 0) + 1;
//     return acc;
//   }, {});

//   return (
//     <Box
//       sx={{
//         position: "relative",
//         minHeight: 0,
//         height: "100%",
//         display: "flex",
//         flexDirection: "column",
//         overflow: "hidden",
//       }}
//     >
//       <InlineGrammarPopup
//         popup={inlinePopup}
//         onClose={() =>
//           setInlinePopup((prev) => ({
//             ...prev,
//             visible: false,
//             suggestion: null,
//           }))
//         }
//         onReplace={() =>
//           inlinePopup.suggestion && handleAccept(inlinePopup.suggestion)
//         }
//         onIgnore={() =>
//           inlinePopup.suggestion && handleIgnore(inlinePopup.suggestion)
//         }
//         onExplain={() => {
//           if (!inlinePopup.suggestion) return;
//           handleExpand(inlinePopup.suggestion);
//           scrollToAccordion(
//             inlinePopup.suggestion.errored_text,
//             inlinePopup.suggestion.value,
//           );
//         }}
//       />

//       {/* Loading overlay */}
//       {suggestionLoader && (
//         <Box
//           sx={{
//             position: "absolute",
//             inset: 0,
//             bgcolor: "rgba(255,255,255,0.85)",
//             zIndex: 10,
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//             justifyContent: "center",
//             gap: 1.5,
//             borderRadius: R.lg,
//           }}
//         >
//           <BeatLoader size={12} color={C.accent} loading />
//           <Typography
//             sx={{ fontSize: "0.8rem", color: C.textMuted, fontWeight: 500 }}
//           >
//             Analyzing your text…
//           </Typography>
//           <LinearProgress
//             sx={{
//               width: 120,
//               height: 3,
//               borderRadius: 2,
//               bgcolor: C.accentLight,
//               "& .MuiLinearProgress-bar": { bgcolor: C.accent },
//             }}
//           />
//         </Box>
//       )}

//       {/* Error type summary pills */}
//       {/* {suggestionArray.length > 0 && (
//         <Box
//           sx={{
//             display: "flex",
//             flexWrap: "wrap",
//             gap: 0.75,
//             px: 2,
//             pb: 1.5,
//             pt: 0.5,
//           }}
//         >
//           {Object.entries(errorCounts).map(([type, count]) => {
//             const config = getErrorConfig(type);
//             return (
//               <Chip
//                 key={type}
//                 icon={config.icon}
//                 label={`${type} · ${count}`}
//                 size="small"
//                 sx={{
//                   height: 22,
//                   fontSize: "0.7rem",
//                   fontWeight: 700,
//                   bgcolor: config.bg,
//                   color: config.color,
//                   border: `1px solid ${config.color}30`,
//                   "& .MuiChip-icon": { color: config.color, ml: 0.5 },
//                 }}
//               />
//             );
//           })}
//         </Box>
//       )} */}
//       {suggestionArray.length > 0 && (
//         <ErrorChipSummary
//           errorCounts={errorCounts}
//           C={C}
//           R={R}
//           getErrorConfig={getErrorConfig}
//         />
//       )}

//       {/* Suggestion cards */}
//       <Box
//         sx={{
//           px: 2,
//           pb: 2,
//           flex: 1,
//           minHeight: 0,
//           overflowY: "auto",
//           overflowX: "auto",
//         }}
//       >
//         {/* {suggestionArray.length === 0 && !suggestionLoader ? (
//           <EmptyState />
//         ) : ( */}
//         {suggestionLoader || isStreaming ? (
//           // ✅ SHOW LOADER ONLY
//           <></> // (you already have overlay loader above)
//         ) : suggestionArray.length === 0 ? (
//           <EmptyState />
//         ) : (
//           suggestionArray.map((suggestion, i) => (
//             <div key={i} className="cgsuggestion" ref={accordionRef}>
//               <SuggestionCard
//                 suggestion={suggestion}
//                 expanded={expanded}
//                 onExpand={handleExpand}
//                 onAccept={handleAccept}
//                 onIgnore={handleIgnore}
//                 mobileView={mobileView}
//               />
//             </div>
//           ))
//         )}
//       </Box>
//     </Box>
//   );
// };

// export default SuggestionComp;




import React, { useState, useEffect, useRef, useCallback } from "react";
import _ from "lodash";
import { ContentState, EditorState, Modifier, SelectionState } from "draft-js";
import DocumentService from "../../services/document";
import { strCount } from "../Editor/utilize";
import { useSelector } from "react-redux";
import {
  Accordion,
  AccordionActions,
  AccordionDetails,
  AccordionSummary,
  Button,
  IconButton,
  Typography,
  Box,
  Chip,
  Divider,
  LinearProgress,
  Tooltip,
  Fade,
  Badge,
} from "@mui/material";
import { BeatLoader } from "react-spinners";
import { css } from "@emotion/react";
import GrammarIcon from "@mui/icons-material/Spellcheck";
import StyleIcon from "@mui/icons-material/AutoFixHigh";
import ClarityIcon from "@mui/icons-material/Visibility";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CloseIcon from "@mui/icons-material/Close";
import TipsAndUpdatesIcon from "@mui/icons-material/TipsAndUpdates";
import Grid from "@mui/material/Unstable_Grid2";
import Popover from "@mui/material/Popover";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { toast, ToastContainer } from "react-toastify";
import synlogo from "../../static/POET_Logo_Pen.png";

// ─── DESIGN TOKENS ──────────────────────────────────────────────────────────
const C = {
  bg: "#f0f2f8",
  surface: "#ffffff",
  border: "rgba(99,120,180,0.14)",
  accent: "#4f6ef7",
  accentLight: "#cdd3ee",
  success: "#22c55e",
  successLight: "#f0fdf4",
  error: "#ef4444",
  errorLight: "#fef2f2",
  warning: "#f59e0b",
  warningLight: "#fffbeb",
  purple: "#8b5cf6",
  purpleLight: "#f5f3ff",
  textPrimary: "#1a1d2e",
  textSecondary: "#64748b",
  textMuted: "#434343",
};

const R = { sm: "8px", md: "12px", lg: "16px" };

const POPUP_ACTION_COLOR = "#2b62bb";
const POPUP_ACTION_HOVER = "#3a6cbb";

const replaceFirstInEditorHTML = (html, search, replacement) => {
  if (!html || !search) return html;
  const doc = new DOMParser().parseFromString(
    `<div id="__root">${html}</div>`,
    "text/html"
  );
  const root = doc.getElementById("__root");
  if (!root) return html;
  const walker = doc.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  let node;
  while ((node = walker.nextNode())) {
    const idx = node.nodeValue.indexOf(search);
    if (idx !== -1) {
      node.nodeValue =
        node.nodeValue.slice(0, idx) +
        replacement +
        node.nodeValue.slice(idx + search.length);
      return root.innerHTML;
    }
  }
  return html;
};


const getSafeReplacementPair = (
  suggestion = {},
  paragraphText = "",
  preferPhrase = false,
) => {
  const phraseWrong = suggestion.phrase || "";
  const phraseCorrect = suggestion.corrective_text_phrase || "";
  const wordWrong =
    suggestion.errored_text ||
    suggestion.value ||
    suggestion.original_text ||
    suggestion.incorrect ||
    suggestion.actual ||
    "";
  const rawCorrect =
    suggestion.corrective_text ||
    suggestion.corrected_text ||
    suggestion.suggestion ||
    suggestion.expected?.[0] ||
    "";
  const wordCorrect =
    rawCorrect && rawCorrect !== phraseCorrect
      ? rawCorrect
      : !phraseWrong
        ? rawCorrect
        : "";
  const paragraph = String(paragraphText || "").toLowerCase();

  if (
    preferPhrase &&
    phraseWrong &&
    phraseCorrect &&
    phraseWrong !== phraseCorrect &&
    paragraph.includes(phraseWrong.toLowerCase())
  ) {
    return { wrong: phraseWrong, correct: phraseCorrect, kind: "phrase" };
  }

  if (wordWrong && wordCorrect && wordWrong !== wordCorrect) {
    return { wrong: wordWrong, correct: wordCorrect, kind: "word" };
  }

  if (phraseWrong && phraseCorrect && phraseWrong !== phraseCorrect) {
    return { wrong: phraseWrong, correct: phraseCorrect, kind: "phrase" };
  }

  return null;
};

// ─── ERROR TYPE CONFIG ────────────────────────────────────────────────────────
const getErrorConfig = (type = "") => {
  const t = type.toLowerCase();
  if (t.includes("grammar") || t.includes("grammatical"))
    return {
      color: C.error,
      bg: C.errorLight,
      label: "Grammar",
      icon: <GrammarIcon sx={{ fontSize: 13 }} />,
    };
  if (t.includes("spell"))
    return {
      color: C.warning,
      bg: C.warningLight,
      label: "Spelling",
      icon: <GrammarIcon sx={{ fontSize: 13 }} />,
    };
  if (t.includes("style"))
    return {
      color: C.purple,
      bg: C.purpleLight,
      label: "Style",
      icon: <StyleIcon sx={{ fontSize: 13 }} />,
    };
  if (t.includes("clarity"))
    return {
      color: C.accent,
      bg: C.accentLight,
      label: "Clarity",
      icon: <ClarityIcon sx={{ fontSize: 13 }} />,
    };
  return {
    color: C.textSecondary,
    bg: "#f8fafc",
    label: type || "Issue",
    icon: <SwapHorizIcon sx={{ fontSize: 13 }} />,
  };
};

const override = css`
  position: absolute;
  left: 42%;
  top: 50%;
  margin: 0 auto;
  z-index: 9999;
`;

// ─── EMPTY STATE ─────────────────────────────────────────────────────────────
const EmptyState = () => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      py: 6,
      px: 3,
      gap: 1.5,
    }}
  >
    <Box
      sx={{
        width: 56,
        height: 56,
        borderRadius: "50%",
        bgcolor: C.successLight,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        mb: 0.5,
      }}
    >
      <CheckCircleOutlineIcon sx={{ fontSize: 28, color: C.success }} />
    </Box>
    <Typography
      sx={{ fontWeight: 700, color: C.textPrimary, fontSize: "0.95rem" }}
    >
      All good!
    </Typography>
    <Typography
      sx={{
        color: C.textMuted,
        fontSize: "0.82rem",
        textAlign: "center",
        lineHeight: 1.5,
      }}
    >
      No suggestions found. Your writing looks great.
    </Typography>
  </Box>
);

// ─── GRAMMARLY-STYLE INLINE POPUP ─────────────────────────────────────────────
// Shows when user clicks a highlighted error in the editor – mimics the UI in
// the reference screenshot (green header "Fix critical mistakes", strikethrough
// original → bold correction, Accept / Dismiss buttons).
const GrammarlyPopup = ({
  popup,
  onClose,
  onAccept,
  onDismiss,
  onApplyParagraph,
}) => {
  const paragraphSuggestions = Array.isArray(popup?.paragraphSuggestions)
    ? popup.paragraphSuggestions
    : [];
  const hasParagraphFixes = paragraphSuggestions.length > 0;
  const activeSuggestion = popup?.suggestion || paragraphSuggestions[0];

  if (!popup?.visible || !activeSuggestion) return null;

  const config = getErrorConfig(activeSuggestion.type_of_error || "");
  const wrongText =
    activeSuggestion.errored_text || activeSuggestion.value || "";
  const correctText =
    activeSuggestion.corrective_text ||
    activeSuggestion.corrective_text_phrase ||
    "";
  const paragraphText = popup.paragraphText || "";

  return (
    <Box
      onMouseDown={(e) => e.preventDefault()}
      sx={{
        position: "fixed",
        top: hasParagraphFixes ? "50%" : popup.y,
        left: hasParagraphFixes ? "50%" : popup.x,
        transform: hasParagraphFixes
          ? "translate(-50%, -50%)"
          : "translate(-50%, -112%)",
        zIndex: 9999,
        width: hasParagraphFixes ? "min(720px, calc(100vw - 40px))" : "auto",
        minWidth: hasParagraphFixes ? 460 : 320,
        maxWidth: hasParagraphFixes ? "calc(100vw - 40px)" : 400,
        borderRadius: "16px",
        background: "#ffffff",
        border: "1px solid rgba(0,0,0,0.10)",
        boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
        overflow: "visible",
        "&::after": {
          content: '""',
          display: hasParagraphFixes ? "none" : "block",
          position: "absolute",
          left: "50%",
          bottom: -7,
          width: 14,
          height: 14,
          background: "#ffffff",
          borderRight: "1px solid rgba(0,0,0,0.10)",
          borderBottom: "1px solid rgba(0,0,0,0.10)",
          transform: "translateX(-50%) rotate(45deg)",
        },
      }}
    >
      {/* ── Green header bar ── */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: 1.75,
          py: 1,
          borderRadius: "16px 16px 0 0",
          background: POPUP_ACTION_COLOR,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
          {/* small "G" circle icon */}
          <Box
            component="img"
            src={synlogo}
            alt="logo"
            sx={{
              width: 22,
              height: 22,
              objectFit: "contain",
              borderRadius: "4px",
              background: "#ffffff",
              padding: "2px",
            }}
          />
          <Typography
            sx={{ fontSize: "0.78rem", fontWeight: 700, color: "#ffffff" }}
          >
            {hasParagraphFixes
              ? "Fix paragraph issues"
              : "Fix critical mistakes"}
          </Typography>
        </Box>
        <IconButton
          size="small"
          onClick={onClose}
          sx={{
            width: 22,
            height: 22,
            color: "rgba(255,255,255,0.8)",
            "&:hover": { color: "#ffffff", bgcolor: "rgba(255,255,255,0.15)" },
            p: 0,
          }}
        >
          <CloseIcon sx={{ fontSize: 14 }} />
        </IconButton>
      </Box>

      {/* ── Body – inline correction preview ── */}
      <Box sx={{ px: 2, py: 1.5 }}>
        {hasParagraphFixes ? (
          <>
            <Typography
              sx={{
                fontSize: "0.78rem",
                color: C.textSecondary,
                mb: 1,
                fontWeight: 600,
              }}
            >
              Click Apply fix once to correct all highlighted issues in this
              paragraph.
            </Typography>
            <Box
              sx={{
                maxHeight: 260,
                overflowY: "auto",
                pr: 0.75,
                fontSize: "0.9rem",
                lineHeight: 1.7,
                color: "#1a1d2e",
              }}
            >
              {renderParagraphPreview(paragraphText, paragraphSuggestions)}
            </Box>
          </>
        ) : (
          <Typography
            sx={{ fontSize: "0.9rem", lineHeight: 1.65, color: "#1a1d2e" }}
          >
            {/* We reconstruct the sentence snippet showing strike + correction */}
            <span
              style={{
                textDecoration: "line-through",
                color: "#9b1c1c",
                marginRight: 4,
              }}
            >
              {wrongText}
            </span>
            <span style={{ fontWeight: 700, color: "#1a7f5a" }}>
              {correctText}
            </span>
          </Typography>
        )}

        {/* Justification */}
        {!hasParagraphFixes && activeSuggestion.justification && (
          <Typography
            sx={{
              fontSize: "0.75rem",
              color: C.textSecondary,
              mt: 0.75,
              lineHeight: 1.45,
            }}
          >
            {activeSuggestion.justification}
          </Typography>
        )}
      </Box>

      {/* ── Action buttons ── */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          px: 2,
          pb: 1.5,
        }}
      >
        <Button
          onClick={hasParagraphFixes ? onApplyParagraph : onAccept}
          sx={{
            borderRadius: "10px",
            textTransform: "none",
            fontWeight: 700,
            fontSize: "0.82rem",
            px: 2.5,
            py: 0.65,
            color: "#ffffff",
            bgcolor: POPUP_ACTION_COLOR,
            "&:hover": { bgcolor: POPUP_ACTION_HOVER },
            boxShadow: "none",
          }}
          variant="contained"
          disableElevation
        >
          {hasParagraphFixes ? "Apply fix once" : "Accept"}
        </Button>
        <Button
          onClick={hasParagraphFixes ? onClose : onDismiss}
          sx={{
            borderRadius: "10px",
            textTransform: "none",
            fontWeight: 600,
            fontSize: "0.82rem",
            px: 2,
            py: 0.65,
            color: C.error,
            bgcolor: "transparent",
            "&:hover": { bgcolor: "#f1f5f9" },
            border: "none",
          }}
        >
          Dismiss
        </Button>
      </Box>
    </Box>
  );
};

// ─── SUGGESTION CARD ─────────────────────────────────────────────────────────
const renderParagraphPreview = (text, suggestions) => {
  if (!text) return null;

  const fixes = suggestions
    .map((suggestion) => getSafeReplacementPair(suggestion, text, true))
    .filter(Boolean)
    .sort((a, b) => b.wrong.length - a.wrong.length);

  const parts = [];
  let cursor = 0;

  while (cursor < text.length) {
    let match = null;
    let matchIndex = -1;

    fixes.forEach((fix) => {
      const index = text.toLowerCase().indexOf(fix.wrong.toLowerCase(), cursor);
      if (index !== -1 && (matchIndex === -1 || index < matchIndex)) {
        match = fix;
        matchIndex = index;
      }
    });

    if (!match || matchIndex === -1) {
      parts.push(text.slice(cursor));
      break;
    }

    if (matchIndex > cursor) parts.push(text.slice(cursor, matchIndex));
    const original = text.slice(matchIndex, matchIndex + match.wrong.length);
    parts.push(
      <React.Fragment key={`${matchIndex}-${match.wrong}`}>
        <span style={{ color: "#6b7280", textDecoration: "line-through" }}>
          {original}
        </span>
        <span style={{ color: "#0f766e", fontWeight: 800 }}>
          {match.correct}
        </span>
      </React.Fragment>,
    );
    cursor = matchIndex + match.wrong.length;
  }

  return parts;
};

const SuggestionCard = ({
  suggestion,
  expanded,
  onExpand,
  onAccept,
  onIgnore,
  mobileView,
}) => {
  const config = getErrorConfig(suggestion.type_of_error);

  return (
    <Accordion
      expanded={expanded === suggestion.errored_text}
      onChange={() => onExpand(suggestion)}
      id={`accordion-${suggestion.errored_text}`}
      disableGutters
      elevation={0}
      sx={{
        border: `1.5px solid ${expanded === suggestion.errored_text ? config.color + "40" : C.border}`,
        borderRadius: `${R.md} !important`,
        mb: 1.25,
        overflow: "hidden",
        transition: "all 0.2s ease",
        "&:before": { display: "none" },
        "&.Mui-expanded": {
          boxShadow: `0 4px 16px ${config.color}18`,
        },
      }}
    >
      <AccordionSummary
        expandIcon={
          <ExpandMoreIcon
            sx={{
              fontSize: 18,
              color:
                expanded === suggestion.errored_text
                  ? config.color
                  : C.textMuted,
              transition: "color 0.2s",
            }}
          />
        }
        sx={{
          px: 2,
          py: 0.5,
          minHeight: 52,
          bgcolor: expanded === suggestion.errored_text ? config.bg : C.surface,
          transition: "background-color 0.2s",
          "&:hover": { bgcolor: config.bg },
          "& .MuiAccordionSummary-content": {
            margin: "10px 0",
            alignItems: "center",
            gap: 1,
          },
        }}
      >
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "0.83rem",
              color: config.color,
              textDecoration: "line-through",
              textDecorationColor: config.color + "80",
              letterSpacing: "-0.01em",
              whiteSpace: "normal",
              overflowWrap: "break-word",
            }}
          >
            {suggestion.errored_text}
          </Typography>
        </Box>
        <Chip
          icon={config.icon}
          label={config.label}
          size="small"
          sx={{
            height: 22,
            fontSize: "0.7rem",
            fontWeight: 700,
            bgcolor: config.bg,
            color: config.color,
            border: `1px solid ${config.color}30`,
            "& .MuiChip-icon": { color: config.color, ml: 0.5 },
            flexShrink: 0,
          }}
        />
      </AccordionSummary>

      <AccordionDetails
        sx={{
          px: 2,
          py: 1.5,
          bgcolor: C.surface,
          borderTop: `1px solid ${C.border}`,
        }}
      >
        {/* Replace with */}
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            gap: 1,
            mb: 1.5,
            p: 1.25,
            borderRadius: R.sm,
            bgcolor: C.accentLight,
            border: `1px solid ${C.accent}25`,
          }}
        >
          <SwapHorizIcon
            sx={{ fontSize: 16, color: C.accent, mt: 0.15, flexShrink: 0 }}
          />
          <Box>
            <Typography
              sx={{
                fontSize: "0.72rem",
                fontWeight: 600,
                color: C.textMuted,
                mb: 0.25,
                textTransform: "uppercase",
                letterSpacing: "0.04em",
              }}
            >
              Replace with
            </Typography>
            <Typography
              sx={{ fontSize: "0.85rem", fontWeight: 700, color: C.accent }}
            >
              &ldquo;{suggestion.corrective_text}&rdquo;
            </Typography>
          </Box>
        </Box>

        {/* Justification */}
        {suggestion.justification && (
          <Box sx={{ mb: 0.5 }}>
            <Typography
              sx={{
                fontSize: "0.72rem",
                fontWeight: 600,
                color: C.textMuted,
                mb: 0.5,
                textTransform: "uppercase",
                letterSpacing: "0.04em",
              }}
            >
              Why
            </Typography>
            <Typography
              sx={{
                fontSize: "0.82rem",
                color: C.textSecondary,
                lineHeight: 1.55,
              }}
            >
              {suggestion.justification}
            </Typography>
          </Box>
        )}
      </AccordionDetails>

      <AccordionActions
        sx={{
          px: 2,
          py: 1.25,
          bgcolor: "#fafbff",
          borderTop: `1px solid ${C.border}`,
          gap: 1,
        }}
      >
        <Button
          size="small"
          variant="outlined"
          onClick={() => onIgnore(suggestion)}
          sx={{
            borderRadius: R.md,
            textTransform: "none",
            fontWeight: 600,
            fontSize: "0.78rem",
            flex: 1,
            borderWidth: 1.5,
            borderColor: C.error + "60",
            color: C.error,
            "&:hover": {
              borderColor: C.error,
              bgcolor: C.errorLight,
            },
          }}
        >
          Ignore
        </Button>
        <Button
          size="small"
          variant="contained"
          onClick={() => onAccept(suggestion)}
          sx={{
            borderRadius: R.md,
            textTransform: "none",
            fontWeight: 600,
            fontSize: "0.78rem",
            flex: 1,
            bgcolor: C.accent,
            boxShadow: "none",
            "&:hover": {
              bgcolor: "#3a57d4",
              boxShadow: "none",
            },
          }}
        >
          Accept
        </Button>
      </AccordionActions>
    </Accordion>
  );
};

// ────────────────────────────────────────────────────────────────────────────
// MAIN SuggestionComp
// ────────────────────────────────────────────────────────────────────────────
const SuggestionComp = ({
  mobileView,
  autoSaveContent,
  docName,
  docId,
  newDocId,
  folderId,
  tags,
  ignoreAllClicked,
  setIgnoreAllClicked,
  acceptAllClicked,
  setAcceptAllClicked,
  setEditorContentUpload,
  editorContent,
  changedSentence,
  setSentenceResult,
  setState,
  setIsFeatureButton,
  editorState,
  setEditorState,
  setIsSuggestion,
  copiedText,
  editor,
  setIsType,
  ignoredSuggestions,
  windowWidth,
  setOldSentences,
  oldSentences,
  setNewSentences,
  newSentences,
    suggestionLoader,
  editorValue,
  isStreaming,
  setEditorValue,  
  setVisibleSuggestionCount,
   skipNextGrammarCheckRef, 
}) => {
  const escapeRegex = (v = "") => v.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  const getWrongText = (item = {}) =>
    item.errored_text ||
    item.value ||
    item.phrase ||
    item.original_text ||
    item.incorrect ||
    item.actual ||
    "";

  const getCorrectText = (item = {}) =>
    item.corrective_text ||
    item.corrective_text_phrase ||
    item.corrected_text ||
    item.suggestion ||
    item.expected?.[0] ||
    "";

  const getSuggestionKey = (item = {}) =>
    `${getWrongText(item)}|||${getCorrectText(item)}`;

  const getSuggestionValue = getWrongText;
  const getSuggestionCorrection = getCorrectText;
  const getSuggestionMatchText = getWrongText;
  const getSuggestionReplacementText = getCorrectText;

  const [suggestionArray, setSuggestionArray] = useState([]);
  const [isColorChange, setIsColorChange] = useState(true);
  const [clickedWord, setClickedWord] = useState("");
  const { isFullSize } = useSelector((state) => state?.manageFullSizeEditor);
  const { isFullScreen } = useSelector((state) => state?.manageFullSizeEditor);
  const [expanded, setExpanded] = useState();
  const [errorValue, setErrorValue] = useState("");
  const [paragraphDialogOpen, setParagraphDialogOpen] = useState(false);
  const [activeParagraph, setActiveParagraph] = useState("");
  const [activeParagraphErrors, setActiveParagraphErrors] = useState([]);
  const [activeParagraphIndex, setActiveParagraphIndex] = useState(-1);

  // ── FIX: single state for the grammarly-style inline popup ──────────────
  const [grammarlyPopup, setGrammarlyPopup] = useState({
    visible: false,
    x: 0,
    y: 0,
    suggestion: null,
    paragraphEl: null,
    paragraphText: "",
    paragraphSuggestions: [],
  });

  const accordionRef = useRef(null);
  const [wordsCount, characterCount] = strCount(editorContent.toString());

  // ✅ NEW: strict validation
  const isValidReplacement = (wrong, correct) => {
    if (!wrong || !correct) return false;

    const w = wrong.trim().toLowerCase();
    const c = correct.trim().toLowerCase();

    if (w === c) return false; // same text
    if (c.includes(w)) return false; // repetition risk
    if (w.includes(c)) return false; // useless replace
    if (c.split(" ").length > w.split(" ").length + 5) return false;

    return true;
  };

 // ✅ FIXED: cleanText — handles word repetition, phrase repetition, AND sentence duplication
const cleanText = (text) => {
  // 1. Remove immediately repeated words (e.g. "company company")
  text = text.replace(/\b(\w+)(\s+\1)+\b/gi, '$1');

  // 2. Remove repeated short phrases up to 6 words
  text = text.replace(/\b((?:\w+\s+){1,5}\w+)\s+\1\b/gi, '$1');

  // 3. Sentence-level deduplication — split on sentence boundary, dedupe, rejoin
  const sentences = text.match(/[^.!?]+[.!?]+["']?|[^.!?]+$/g) || [text];
  const seen = new Set();
  const deduped = sentences.filter(s => {
    const key = s.trim().toLowerCase().replace(/\s+/g, ' ');
    if (!key || seen.has(key)) return false;
    seen.add(key);
    return true;
  });
  text = deduped.join(' ');

  // 4. Fix spacing
  text = text.replace(/\s+/g, ' ').replace(/\s+([.,!?])/g, '$1').trim();
  return text;
};



  // ────────────────────────────────────────────────────────────────────────
  // acceptAllClicked / ignoreAllClicked
  // ────────────────────────────────────────────────────────────────────────
  useEffect(() => {
    if (!acceptAllClicked) return;
    const toAccept =
      suggestionArray.length > 0
        ? suggestionArray
        : Array.isArray(changedSentence)
          ? changedSentence
          : [];
    handleAcceptAll(toAccept);
    setAcceptAllClicked(false);
  }, [acceptAllClicked]);

  useEffect(() => {
    if (ignoreAllClicked) handleIgnoreAll(suggestionArray);
    setIgnoreAllClicked(false);
  }, [ignoreAllClicked]);

  const findParagraphElement = (node) => {
    if (!editor.current || !node) return null;
    const element =
      node.nodeType === Node.TEXT_NODE ? node.parentElement : node;
    const block = element?.closest?.("p, div, li, h1, h2, h3, h4, h5, h6");
    if (block && editor.current.contains(block) && block !== editor.current) {
      return block;
    }
    return editor.current;
  };

  const suggestionBelongsToText = (suggestion, text = "") => {
    const haystack = text.toLowerCase();
    const candidates = [
      suggestion.value,
      suggestion.errored_text,
      suggestion.phrase,
      suggestion.original_text,
      suggestion.incorrect,
      suggestion.actual,
    ]
      .filter(Boolean)
      .map((v) => String(v).toLowerCase());

    return candidates.some((candidate) => haystack.includes(candidate));
  };

  const getParagraphSuggestions = (paragraphEl) => {
    const paragraphText = paragraphEl?.innerText || "";
    const highlightedKeys = new Set(
      Array.from(
        paragraphEl?.querySelectorAll?.("span.highlighted-error") || [],
      )
        .map((span) => decodeURIComponent(span.dataset.suggestionKey || ""))
        .filter(Boolean),
    );
    const paragraphSuggestions =
      highlightedKeys.size > 0
        ? suggestionArray.filter((suggestion) =>
            highlightedKeys.has(getSuggestionKey(suggestion)),
          )
        : suggestionArray.filter((suggestion) =>
            suggestionBelongsToText(suggestion, paragraphText),
          );

    return { paragraphText, paragraphSuggestions };
  };

  const openParagraphPopup = (
    event,
    paragraphEl,
    fallbackSuggestion = null,
  ) => {
    const { paragraphText, paragraphSuggestions } =
      getParagraphSuggestions(paragraphEl);
    if (paragraphSuggestions.length === 0) return false;

    const rect = paragraphEl.getBoundingClientRect();
    const x = event?.clientX || rect.left + Math.min(rect.width / 2, 360);
    const y = Math.max(event?.clientY || rect.top, rect.top + 20);

    setGrammarlyPopup({
      visible: true,
      x,
      y,
      suggestion: fallbackSuggestion || paragraphSuggestions[0],
      paragraphEl,
      paragraphText,
      paragraphSuggestions,
    });

    return true;
  };

  // ────────────────────────────────────────────────────────────────────────
  // Click handler on highlighted errors → show grammarly popup
  // ────────────────────────────────────────────────────────────────────────
  useEffect(() => {
    const handleClick = (event) => {
      if (!editor.current || !editor.current.contains(event.target)) return;

      const selectedText = window.getSelection?.()?.toString()?.trim();
      if (selectedText) return;

      const el = event.target.closest(".highlighted-error");
      const paragraphEl = findParagraphElement(event.target);

      if (!el) {
        if (openParagraphPopup(event, paragraphEl)) {
          event.preventDefault();
          event.stopPropagation();
        }
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      const word = decodeURIComponent(el.dataset.word || "");
      const displayWord = decodeURIComponent(el.dataset.displayWord || "");
      const suggestionKey = decodeURIComponent(el.dataset.suggestionKey || "");

      const match =
        suggestionArray.find(
          (item) => getSuggestionKey(item) === suggestionKey,
        ) ||
        suggestionArray.find(
          (item) =>
            item.errored_text === word ||
            item.value === displayWord ||
            item.value === word,
        ) ||
        null;

      if (match) {
        openParagraphPopup(event, paragraphEl, match);
      }
      scrollToAccordion(word, displayWord);
    };

    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, [suggestionArray]);

  // ────────────────────────────────────────────────────────────────────────
  // Ignore all
  // ────────────────────────────────────────────────────────────────────────
  const handleIgnoreAll = async (suggestions) => {
    suggestions.forEach(async (sentence) => {
      let filterSentence = suggestionArray.filter(
        (item) => item.value !== sentence.value,
      );
      setSuggestionArray(filterSentence);
      if (filterSentence.length === 0) {
        setSentenceResult([]);
        setIsSuggestion(false);
      }
      colorWord(sentence.value, sentence.errored_text, "black", sentence);
      highLightWords(sentence.value, "white");
    });
    setSentenceResult([]);
    setIsColorChange(false);
    setIsSuggestion(false);
  };

  // ────────────────────────────────────────────────────────────────────────
  // Accept all
  // ────────────────────────────────────────────────────────────────────────
  const handleAcceptAll = (suggestions) => {
    if (!editor.current || !Array.isArray(suggestions)) return;

    if (isStreaming) {
      toast.warn("Wait until grammar check completes");
      return;
    }

    let text = editor.current.innerText;

    const isValid = (wrong, correct) => {
      if (!wrong || !correct) return false;
      if (wrong === correct) return false;
      if (wrong.length > 20 && correct.length < 3) return false;
      return true;
    };

    const normalized = suggestions.map((s) => ({
      phraseWrong: s.phrase,
      phraseCorrect: s.corrective_text_phrase,
      wordWrong: s.errored_text,
      wordCorrect: s.corrective_text,
    }));

    const phraseFixes = normalized
      .filter((s) => isValid(s.phraseWrong, s.phraseCorrect))
      .sort((a, b) => b.phraseWrong.length - a.phraseWrong.length);

    phraseFixes.forEach(({ phraseWrong, phraseCorrect }) => {
      const escaped = phraseWrong.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      const regex = new RegExp(escaped, "g");
      if (text.includes(phraseWrong)) text = text.replace(regex, phraseCorrect);
    });

    const wordFixes = normalized
      .filter(
        (s) => s.wordWrong && s.wordCorrect && s.wordWrong !== s.wordCorrect,
      )
      .sort((a, b) => b.wordWrong.length - a.wordWrong.length);

    wordFixes.forEach(({ wordWrong, wordCorrect }) => {
      const escaped = wordWrong.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      const isWord = /^[a-zA-Z]+$/.test(wordWrong);
      const regex = isWord
        ? new RegExp(`\\b${escaped}\\b`, "g")
        : new RegExp(escaped, "g");
      if (text.includes(wordWrong)) text = text.replace(regex, wordCorrect);
    });
    text = cleanText(text);
    editor.current.innerText = text;

    editor.current.querySelectorAll("span").forEach((span) => {
      span.replaceWith(document.createTextNode(span.textContent));
    });

    setSuggestionArray([]);
    setSentenceResult([]);
    setIsSuggestion(false);
    setIsColorChange(false);
    setGrammarlyPopup({ visible: false, x: 0, y: 0, suggestion: null });
  };

  // ────────────────────────────────────────────────────────────────────────
  // colorWord / highLightWords / focusEditorOnSuggestion / scrollToAccordion
  // ────────────────────────────────────────────────────────────────────────
  const colorWord = (word, errorWord, color, suggestion = null) => {
    if (!editor.current || !word) return;
    const root = editor.current;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      const text = node.nodeValue;
      if (!text.toLowerCase().includes(word.toLowerCase())) continue;
      const parts = text.split(new RegExp(`(${escapeRegex(word)})`, "gi"));
      const fragment = document.createDocumentFragment();
      parts.forEach((part) => {
        if (part.toLowerCase() === word.toLowerCase()) {
          const span = document.createElement("span");
          span.style.color = color;
          span.style.cursor = "text";
          span.style.userSelect = "text";
          span.style.webkitUserSelect = "text";
          span.dataset.displayWord = encodeURIComponent(word || "");
          span.dataset.word = encodeURIComponent(errorWord || "");
          span.dataset.suggestionKey = encodeURIComponent(
            getSuggestionKey(
              suggestion || { value: word, errored_text: errorWord },
            ),
          );
          span.className = "highlighted-error";
          span.textContent = part;
          fragment.appendChild(span);
        } else {
          fragment.appendChild(document.createTextNode(part));
        }
      });
      node.replaceWith(fragment);
    }
  };

  window.handleHighlightedWordClick = (event, el) => {
    event.preventDefault();
    event.stopPropagation();
    const word = decodeURIComponent(el.dataset.word);
    const clickedDisplayWord = decodeURIComponent(el.dataset.displayWord || "");
    scrollToAccordion(word, clickedDisplayWord);
  };

  const lastHighlightedRef = useRef(null);

  const highLightWords = (word, color) => {
    if (!editor.current || !word) return;
    if (lastHighlightedRef.current) {
      lastHighlightedRef.current.style.backgroundColor = "";
    }
    const encodedWord = encodeURIComponent(word);
    const el = editor.current.querySelector(
      `span[data-display-word="${encodedWord}"]`,
    );
    if (el) {
      el.style.backgroundColor = color;
      lastHighlightedRef.current = el;
    }
  };

  const focusEditorOnSuggestion = (word, displayword) => {
    if (!editor.current) return null;
    const root = editor.current;
    const candidates = [
      displayword
        ? `span[data-display-word="${encodeURIComponent(displayword)}"]`
        : null,
      word ? `span[data-word="${encodeURIComponent(word)}"]` : null,
      word ? `span[data-display-word="${encodeURIComponent(word)}"]` : null,
    ].filter(Boolean);

    let target = null;
    for (const selector of candidates) {
      target = root.querySelector(selector);
      if (target) break;
    }

    if (!target && displayword) {
      const spans = Array.from(root.querySelectorAll(".highlighted-error"));
      target =
        spans.find(
          (s) =>
            decodeURIComponent(s.dataset.displayWord || "") === displayword,
        ) ||
        spans.find((s) => decodeURIComponent(s.dataset.word || "") === word) ||
        null;
    }

    if (!target) return null;

    target.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "nearest",
    });

    const range = document.createRange();
    range.selectNodeContents(target);
    const selection = window.getSelection();
    if (selection) {
      selection.removeAllRanges();
      selection.addRange(range);
    }
    root.focus();
    return target;
  };

  const scrollToAccordion = (word, displayword) => {
    const accordionItems = document.querySelectorAll(
      `.cgsuggestion [id^="accordion-"]`,
    );
    let foundItem = null;
    accordionItems.forEach((item) => {
      const erroredText = item.id.replace("accordion-", "");
      if (erroredText === word && !foundItem) foundItem = item;
    });
    if (foundItem) {
      foundItem.scrollIntoView({ behavior: "smooth", block: "center" });
      const accordionSummary = foundItem.querySelector(
        ".MuiAccordionSummary-root",
      );
      if (accordionSummary) {
        accordionSummary.style.backgroundColor = "#e6f7ff";
        setTimeout(() => {
          accordionSummary.style.backgroundColor = "";
        }, 1000);
      }
      if (expanded !== word) {
        setExpanded(word);
        highLightWords(displayword, C.accentLight);
      }
    }
    focusEditorOnSuggestion(word, displayword);
  };

  const handleAcceptSingleLegacy = (suggestion) => {
  if (!editor.current) return;

  const wrong = suggestion.errored_text;
  const correct = suggestion.corrective_text;

  const spans = editor.current.querySelectorAll("span.highlighted-error");

  spans.forEach((span) => {
    const text = span.textContent;

    if (text.toLowerCase() === wrong.toLowerCase()) {
      // ✅ Replace entire span with clean text (NO color)
      span.replaceWith(document.createTextNode(correct));
    }
  });

  // ✅ Normalize DOM
  editor.current.normalize();

  const newHtml = editor.current.innerHTML;

  if (skipNextGrammarCheckRef) skipNextGrammarCheckRef.current = true;

  setEditorValue(newHtml);
  setEditorContentUpload?.(newHtml);
  setEditorState?.(newHtml);

  // remove suggestion
  setSuggestionArray((prev) =>
    prev.filter(
      (e) =>
        !(
          e.errored_text === suggestion.errored_text &&
          e.value === suggestion.value
        )
    )
  );

  setSentenceResult((prev) =>
    prev.filter(
      (e) =>
        !(
          e.errored_text === suggestion.errored_text &&
          e.value === suggestion.value
        )
    )
  );

  setGrammarlyPopup((prev) => ({ ...prev, visible: false }));
};

  const handleAccept = (suggestion) => {
    if (!editor.current || !suggestion) return;

    const wrong = getSuggestionMatchText(suggestion);
    const correct = getSuggestionReplacementText(suggestion);
    if (!wrong || !correct) return;

    const encodedKey = encodeURIComponent(getSuggestionKey(suggestion));
    const scopedRoot =
      grammarlyPopup.paragraphEl &&
      editor.current.contains(grammarlyPopup.paragraphEl)
        ? grammarlyPopup.paragraphEl
        : editor.current;

    let targetSpan = scopedRoot.querySelector(
      `span.highlighted-error[data-suggestion-key="${encodedKey}"]`,
    );

    if (!targetSpan) {
      targetSpan = Array.from(
        scopedRoot.querySelectorAll("span.highlighted-error"),
      ).find((span) => span.textContent.toLowerCase() === wrong.toLowerCase());
    }

    if (targetSpan) {
      targetSpan.replaceWith(document.createTextNode(correct));
    } else {
      const walker = document.createTreeWalker(scopedRoot, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        const text = node.nodeValue || "";
        const index = text.toLowerCase().indexOf(wrong.toLowerCase());
        if (index < 0) continue;

        const range = document.createRange();
        range.setStart(node, index);
        range.setEnd(node, index + wrong.length);
        range.deleteContents();
        range.insertNode(document.createTextNode(correct));
        break;
      }
    }

    editor.current.normalize();

    const newHtml = editor.current.innerHTML;
    if (skipNextGrammarCheckRef) skipNextGrammarCheckRef.current = true;

    setEditorValue?.(editor.current.innerText || "");
    setEditorContentUpload?.(newHtml);
    setEditorState?.(newHtml);

    const acceptedKey = getSuggestionKey(suggestion);
    setSuggestionArray((prev) =>
      prev.filter((item) => getSuggestionKey(item) !== acceptedKey),
    );
    setSentenceResult((prev) =>
      prev.filter((item) => getSuggestionKey(item) !== acceptedKey),
    );

    setGrammarlyPopup({
      visible: false,
      x: 0,
      y: 0,
      suggestion: null,
      paragraphEl: null,
      paragraphText: "",
      paragraphSuggestions: [],
    });
  };
 
const handleApplyParagraphFixes = () => {
  if (!editor.current) return;

  const paragraphEl =
    grammarlyPopup.paragraphEl && editor.current.contains(grammarlyPopup.paragraphEl)
      ? grammarlyPopup.paragraphEl
      : findParagraphElement(
          document.elementFromPoint(grammarlyPopup.x || 0, grammarlyPopup.y || 0),
        );
  if (!paragraphEl || !editor.current.contains(paragraphEl)) return;

  const popupSuggestions = Array.isArray(grammarlyPopup.paragraphSuggestions)
    ? grammarlyPopup.paragraphSuggestions
    : [];
  const suggestions =
    popupSuggestions.length > 0
      ? popupSuggestions
      : getParagraphSuggestions(paragraphEl).paragraphSuggestions;
  if (suggestions.length === 0) return;
  const clone = paragraphEl.cloneNode(true);
  clone.querySelectorAll('span.highlighted-error').forEach(span => {
       span.replaceWith(document.createTextNode(span.textContent));
  });
  clone.normalize();
  let text = clone.innerText || clone.textContent || '';
  // ─────────────────────────────────────────────────────────────────────────────

  const isValidParagraphReplacement = (wrong, correct) => {
    if (!wrong || !correct) return false;
    const w = String(wrong).trim();
    const c = String(correct).trim();
    if (!w || !c || w === c) return false;
    if (w.length > 20 && c.length < 3) return false;
    return true;
  };

  const normalized = suggestions.map((s) => ({
    phraseWrong: s.phrase,
    phraseCorrect: s.corrective_text_phrase,
    wordWrong: s.errored_text,
    wordCorrect: s.corrective_text,
    key: getSuggestionKey(s),
  }));

  const appliedKeys = new Set();
  normalized
    .filter((s) => isValidParagraphReplacement(s.phraseWrong, s.phraseCorrect))
    .sort((a, b) => (b.phraseWrong || '').length - (a.phraseWrong || '').length)
    .forEach(({ phraseWrong, phraseCorrect, key }) => {
      if (!phraseWrong || !phraseCorrect) return;
      const escaped = escapeRegex(phraseWrong);
      const regex = new RegExp(escaped, 'gi');
      if (regex.test(text)) {
        text = text.replace(new RegExp(escaped, 'gi'), phraseCorrect);
        appliedKeys.add(key);
      }
    });

  normalized
    .filter((s) => isValidParagraphReplacement(s.wordWrong, s.wordCorrect))
    .sort((a, b) => (b.wordWrong || '').length - (a.wordWrong || '').length)
    .forEach(({ wordWrong, wordCorrect, key }) => {
      if (!wordWrong || !wordCorrect) return;
      // Skip if this word was already fixed as part of a phrase
      if (appliedKeys.has(key)) return;
      const escaped = escapeRegex(wordWrong);
      const isWord = /^[a-zA-Z]+$/.test(wordWrong);
      const regex = isWord
        ? new RegExp(`\\b${escaped}\\b`, 'gi')
        : new RegExp(escaped, 'gi');
      if (regex.test(text)) {
        text = text.replace(regex, wordCorrect);
        appliedKeys.add(key);
      }
    });

  if (appliedKeys.size === 0) {
    setGrammarlyPopup((prev) => ({ ...prev, visible: false }));
    return;
  }

  // ✅ CLEAN (dedup words, phrases, and whole sentences)
  text = cleanText(text);

  // ✅ WRITE BACK — use innerText to safely set plain text, removing all spans
  paragraphEl.innerText = text;
  paragraphEl.normalize();

  const newHtml = editor.current.innerHTML;
  if (skipNextGrammarCheckRef) skipNextGrammarCheckRef.current = true;
  if (typeof setEditorState === "function") setEditorState(newHtml);
  if (typeof setEditorValue === "function") setEditorValue(newHtml);
  if (typeof setEditorContentUpload === "function") setEditorContentUpload(newHtml);

  const filtered = suggestionArray.filter(
    (item) => !appliedKeys.has(getSuggestionKey(item)),
  );
  setSuggestionArray(filtered);

  if (filtered.length === 0) {
    setSentenceResult([]);
    setIsColorChange(false);
    setIsSuggestion(false);
  }

  setGrammarlyPopup({
    visible: false, x: 0, y: 0, suggestion: null,
    paragraphEl: null, paragraphText: '', paragraphSuggestions: [],
  });
};

  const handleIgnore = async (sentence) => {
    let filterSentence = _.filter(
      suggestionArray,
      (item) => item.value !== sentence.value,
    );
    if (filterSentence.length === 0) {
      setSentenceResult([]);
      setIsSuggestion(false);
    }
    colorWord(sentence.value, sentence.errored_text, "black", sentence);
    highLightWords(sentence.value, "white");
    setSuggestionArray(filterSentence);
    setGrammarlyPopup((prev) => ({
      ...prev,
      visible: false,
      suggestion:
        prev?.suggestion?.value === sentence.value ? null : prev.suggestion,
    }));
  };

  // ────────────────────────────────────────────────────────────────────────
  // Stream results → populate suggestion array
  // ────────────────────────────────────────────────────────────────────────
  const lastProcessedRef = useRef(0);

  useEffect(() => {
    if (!Array.isArray(changedSentence)) return;
    if (changedSentence.length === 0) {
      setSuggestionArray([]);
      lastProcessedRef.current = 0;
      return;
    }
    const fresh = changedSentence.slice(lastProcessedRef.current);
    if (fresh.length > 0) {
      handleFilterValues(fresh);
      lastProcessedRef.current = changedSentence.length;
    }
  }, [changedSentence]);

  const handleFilterValues = (sentence) => {
    const filterValues = sentence.map((item) => ({
      corrective_text:
        item.corrective_text ||
        item.corrective_text_phrase ||
        item.corrected_text ||
        item.suggestion ||
        item.expected?.[0] ||
        "",
      corrective_text_phrase:
        item.corrective_text_phrase || item.corrected_text || "",
      justification: item.justification || "",
      phrase: item.phrase || "",
      type_of_error: item.type_of_error || "",
      value:
        item.value ||
        item.errored_text ||
        item.original_text ||
        item.incorrect ||
        item.actual ||
        item.phrase ||
        "",
      errored_text:
        item.errored_text ||
        item.value ||
        item.original_text ||
        item.incorrect ||
        item.actual ||
        item.phrase ||
        "",
    }));

    const filterSentence = _.filter(
      filterValues,
      (item) =>
        item.type_of_error !== "No error" &&
        item.type_of_error !== "No errors" &&
        item.type_of_error !== "None" &&
        item.type_of_error !== "N/A" &&
        item.type_of_error !== "none" &&
        item.justification !== "No grammatical errors found." &&
        item.justification !== "No error found in the phrase." &&
        item.justification !== "" &&
        item.justification !== "The sentence is grammatically correct." &&
        item.corrective_text !== "" &&
        item.value !== "",
    );

    const finalFilteredValues = filterSentence.filter(
      (s) => !ignoredSuggestions.includes(s.corrective_text),
    );

    if (finalFilteredValues.length === 0) return;

    const flatArray = finalFilteredValues
      .map((v) => v.phrase)
      .filter(Boolean)
      .flatMap((sentence) =>
        sentence
          .replace(/\.+/g, ".")
          .split(".")
          .map((s) => s.trim())
          .filter(Boolean)
          .map((s) => (s.endsWith(".") ? s : s + ".")),
      );

    setNewSentences((prev) => {
      const set = new Set(prev);
      flatArray.forEach((s) => set.add(s));
      return Array.from(set);
    });

    setSuggestionArray((prev) => {
      const merged = [...prev, ...finalFilteredValues];
      const seen = new Map();
      return merged.filter((obj) => {
        const key = getSuggestionKey(obj);
        if (seen.has(key)) return false;
        seen.set(key, true);
        return true;
      });
    });

    setIsSuggestion(true);
  };

  // ────────────────────────────────────────────────────────────────────────
  // When suggestion array changes → highlight first item, open grammarly popup
  // ────────────────────────────────────────────────────────────────────────
  useEffect(() => {
    if (suggestionArray.length > 0) {
      suggestionArray.map((item) =>
        colorWord(item.value, item.errored_text, "red", item),
      );
      setExpanded(suggestionArray[0].errored_text);
      setErrorValue(suggestionArray[0].value);
      setTimeout(() => {
        highLightWords(suggestionArray[0].value, C.accentLight);
      }, 0);

      setTimeout(() => {
        if (!editor.current) return;
        const el = focusEditorOnSuggestion(
          suggestionArray[0].errored_text,
          suggestionArray[0].value,
        );
        if (!el) return;
        const rect = el.getBoundingClientRect();
        setGrammarlyPopup({
          visible: true,
          x: rect.left + rect.width / 2,
          y: rect.top,
          suggestion: suggestionArray[0],
        });
      }, 140);
    } else {
      setGrammarlyPopup({ visible: false, x: 0, y: 0, suggestion: null });
    }
  }, [suggestionArray]);

  // ────────────────────────────────────────────────────────────────────────
  // Expand accordion
  // ────────────────────────────────────────────────────────────────────────
  const handleExpand = (param) => {
    setErrorValue(param.value);
    if (param.value !== errorValue) highLightWords(errorValue, "white");
    setExpanded(param.errored_text);
    highLightWords(param.value, C.accentLight);

    if (editor.current) {
      const el = focusEditorOnSuggestion(param.errored_text, param.value);
      if (el) {
        const rect = el.getBoundingClientRect();
        setGrammarlyPopup({
          visible: true,
          x: rect.left + rect.width / 2,
          y: rect.top,
          suggestion: param,
        });
      }
    }
  };

  // ────────────────────────────────────────────────────────────────────────
  // Error chip summary (overflow popover)
  // ────────────────────────────────────────────────────────────────────────
  const ErrorChipSummary = ({ errorCounts, C, R, getErrorConfig }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [visibleCount, setVisibleCount] = useState(null);
    const containerRef = useRef(null);
    const measureRef = useRef(null);

    const entries = Object.entries(errorCounts);
    const open = Boolean(anchorEl);

    const measure = useCallback(() => {
      const container = measureRef.current;
      if (!container || entries.length === 0) return;
      const chips = Array.from(
        container.querySelectorAll("[data-chip-measure]"),
      );
      if (chips.length === 0) return;
      const baseTop = chips[0].offsetTop;
      let firstRowBottom = baseTop + chips[0].offsetHeight;
      let secondRowBottom = null;
      let count = 0;
      for (const chip of chips) {
        const chipTop = chip.offsetTop;
        const chipBottom = chipTop + chip.offsetHeight;
        if (chipTop <= firstRowBottom + 2) {
          firstRowBottom = Math.max(firstRowBottom, chipBottom);
          count++;
        } else if (secondRowBottom === null || chipTop <= secondRowBottom + 2) {
          if (secondRowBottom === null) secondRowBottom = chipBottom;
          secondRowBottom = Math.max(secondRowBottom, chipBottom);
          count++;
        } else {
          break;
        }
      }
      setVisibleCount(count);
    }, [entries.length]);

    useEffect(() => {
      const el = measureRef.current;
      if (!el) return;
      const raf = requestAnimationFrame(measure);
      const ro = new ResizeObserver(() => requestAnimationFrame(measure));
      ro.observe(el);
      return () => {
        cancelAnimationFrame(raf);
        ro.disconnect();
      };
    }, [measure]);

    const visible =
      visibleCount !== null ? entries.slice(0, visibleCount) : entries;
    const overflow = visibleCount !== null ? entries.slice(visibleCount) : [];
    const hasOverflow = overflow.length > 0;

    const overflowGrouped = overflow.reduce((acc, [type, count]) => {
      const config = getErrorConfig(type);
      const label = config.label;
      if (!acc[label]) acc[label] = [];
      acc[label].push({ type, count, config });
      return acc;
    }, {});

    return (
      <Box sx={{ px: 2, pb: 1.5, pt: 0.5 }}>
        <Box
          ref={measureRef}
          sx={{
            position: "absolute",
            visibility: "hidden",
            pointerEvents: "none",
            display: "flex",
            flexWrap: "wrap",
            gap: "6px",
            left: 0,
            right: 0,
            px: 2,
          }}
        >
          {entries.map(([type, count]) => {
            const config = getErrorConfig(type);
            return (
              <Chip
                key={`measure-${type}`}
                data-chip-measure
                icon={config.icon}
                label={`${type} · ${count}`}
                size="small"
                sx={{ height: 22, fontSize: "0.7rem" }}
              />
            );
          })}
        </Box>

        <Box
          ref={containerRef}
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: "6px",
            alignItems: "center",
          }}
        >
          {visible.map(([type, count]) => {
            const config = getErrorConfig(type);
            return (
              <Chip
                key={type}
                icon={config.icon}
                label={`${type} · ${count}`}
                size="small"
                sx={{
                  height: 22,
                  fontSize: "0.7rem",
                  fontWeight: 700,
                  bgcolor: config.bg,
                  color: config.color,
                  border: `1px solid ${config.color}30`,
                  "& .MuiChip-icon": { color: config.color, ml: 0.5 },
                  transition: "all 0.15s ease",
                  "&:hover": {
                    opacity: 0.85,
                    transform: "translateY(-1px)",
                    boxShadow: `0 3px 8px ${config.color}22`,
                  },
                }}
              />
            );
          })}

          {hasOverflow && (
            <Chip
              label={
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.4 }}>
                  <span>+{overflow.length} more</span>
                  <KeyboardArrowDownIcon
                    sx={{
                      fontSize: 13,
                      transition: "transform 0.2s",
                      transform: open ? "rotate(180deg)" : "rotate(0deg)",
                    }}
                  />
                </Box>
              }
              size="small"
              onClick={(e) => setAnchorEl(e.currentTarget)}
              sx={{
                height: 22,
                fontSize: "0.7rem",
                fontWeight: 700,
                bgcolor: open ? C.accent : C.accentLight,
                color: open ? "#fff" : C.accent,
                border: `1.5px solid ${C.accent}40`,
                cursor: "pointer",
                transition: "all 0.2s ease",
                "&:hover": {
                  bgcolor: C.accent,
                  color: "#fff",
                  boxShadow: `0 4px 12px ${C.accent}35`,
                  transform: "translateY(-1px)",
                },
                "& .MuiChip-label": { px: 1 },
              }}
            />
          )}
        </Box>

        <Popover
          open={open}
          anchorEl={anchorEl}
          onClose={() => setAnchorEl(null)}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
          TransitionProps={{ timeout: 200 }}
          PaperProps={{
            elevation: 0,
            sx: {
              mt: 0.75,
              borderRadius: "16px",
              border: `1px solid ${C.border}`,
              boxShadow: `0 16px 48px rgba(79,110,247,0.14), 0 4px 16px rgba(0,0,0,0.06)`,
              maxWidth: 340,
              minWidth: 260,
              overflow: "hidden",
            },
          }}
        >
          <Box
            sx={{
              px: 2,
              py: 1.25,
              background: `linear-gradient(135deg, ${C.accentLight} 0%, #f0f4ff 100%)`,
              borderBottom: `1px solid ${C.border}`,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography
              sx={{
                fontSize: "0.72rem",
                fontWeight: 800,
                color: C.accent,
                textTransform: "uppercase",
                letterSpacing: "0.08em",
              }}
            >
              More Issues
            </Typography>
            <Box
              sx={{
                height: 20,
                px: 1,
                borderRadius: "10px",
                bgcolor: C.accent,
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{ fontSize: "0.68rem", fontWeight: 700, color: "#fff" }}
              >
                {overflow.length} types
              </Typography>
            </Box>
          </Box>

          <Box sx={{ p: 1.5, maxHeight: 320, overflowY: "auto" }}>
            {Object.entries(overflowGrouped).map(([groupLabel, items], gi) => (
              <Box
                key={groupLabel}
                sx={{
                  mb:
                    gi < Object.entries(overflowGrouped).length - 1 ? 1.25 : 0,
                }}
              >
                <Typography
                  sx={{
                    fontSize: "0.65rem",
                    fontWeight: 700,
                    color: C.textMuted,
                    textTransform: "uppercase",
                    letterSpacing: "0.06em",
                    mb: 0.6,
                    px: 0.25,
                  }}
                >
                  {groupLabel}
                </Typography>
                <Grid container spacing={0.75}>
                  {items.map(({ type, count, config }) => (
                    <Grid key={type} xs="auto">
                      <Chip
                        icon={config.icon}
                        label={`${type} · ${count}`}
                        size="small"
                        sx={{
                          height: 24,
                          fontSize: "0.7rem",
                          fontWeight: 700,
                          bgcolor: config.bg,
                          color: config.color,
                          border: `1px solid ${config.color}25`,
                          "& .MuiChip-icon": { color: config.color, ml: 0.5 },
                          transition: "all 0.15s ease",
                          "&:hover": {
                            bgcolor: config.color,
                            color: "#fff",
                            "& .MuiChip-icon": { color: "#fff" },
                            transform: "translateY(-1px)",
                            boxShadow: `0 4px 10px ${config.color}30`,
                          },
                        }}
                      />
                    </Grid>
                  ))}
                </Grid>
                {gi < Object.entries(overflowGrouped).length - 1 && (
                  <Divider sx={{ mt: 1.25, borderColor: C.border }} />
                )}
              </Box>
            ))}
          </Box>

          <Box
            sx={{
              px: 2,
              py: 1,
              borderTop: `1px solid ${C.border}`,
              bgcolor: "#fafbff",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Typography
              sx={{ fontSize: "0.68rem", color: C.textMuted, fontWeight: 500 }}
            >
              {overflow.reduce((sum, [, c]) => sum + c, 0)} total issues in{" "}
              {overflow.length} categories
            </Typography>
          </Box>
        </Popover>
      </Box>
    );
  };

  // ── count by error type ──────────────────────────────────────────────────
  const errorCounts = suggestionArray.reduce((acc, s) => {
    const type = getErrorConfig(s.type_of_error).label;
    acc[type] = (acc[type] || 0) + 1;
    return acc;
  }, {});

  useEffect(() => {
    if (typeof setVisibleSuggestionCount === "function") {
      setVisibleSuggestionCount(suggestionArray.length);
    }
  }, [setVisibleSuggestionCount, suggestionArray.length]);

  const isCheckingSuggestions = Boolean(suggestionLoader || isStreaming);
  const showInitialLoader =
    isCheckingSuggestions && suggestionArray.length === 0;

  const ParagraphFixHint = () => (
    <Box sx={{ px: 2, pt: 1.25, pb: 1 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.25,
          px: 1.5,
          py: 1.15,
          borderRadius: R.md,
          bgcolor: "#f8fbff",
          border: `1px solid ${C.accent}30`,
          boxShadow: "0 6px 18px rgba(79,110,247,0.08)",
        }}
      >
        <Box
          sx={{
            width: 34,
            height: 34,
            borderRadius: "10px",
            bgcolor: C.accent,
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flex: "0 0 auto",
          }}
        >
          <TipsAndUpdatesIcon sx={{ fontSize: 18 }} />
        </Box>
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Typography
            sx={{ fontSize: "0.78rem", fontWeight: 800, color: C.textPrimary }}
          >
            Paragraph quick fix
          </Typography>
          <Typography
            sx={{
              fontSize: "0.72rem",
              color: C.textSecondary,
              lineHeight: 1.35,
            }}
          >
            Click any paragraph with red marks, then use Apply fix once to
            correct all errors in that paragraph.
          </Typography>
        </Box>
        <Chip
          label="1-click"
          size="small"
          sx={{
            height: 22,
            fontSize: "0.68rem",
            fontWeight: 800,
            bgcolor: C.successLight,
            color: C.success,
            border: `1px solid ${C.success}30`,
          }}
        />
      </Box>
    </Box>
  );

  // ────────────────────────────────────────────────────────────────────────
  // RENDER
  // ────────────────────────────────────────────────────────────────────────
  return (
    <Box
      sx={{
        position: "relative",
        minHeight: 0,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      {/* ── Grammarly-style inline popup (replaces old InlineGrammarPopup) ── */}
      <GrammarlyPopup
        popup={grammarlyPopup}
        onClose={() =>
          setGrammarlyPopup((prev) => ({
            ...prev,
            visible: false,
            suggestion: null,
          }))
        }
        onAccept={() =>
          grammarlyPopup.suggestion && handleAccept(grammarlyPopup.suggestion)
        }
        onDismiss={() =>
          grammarlyPopup.suggestion && handleIgnore(grammarlyPopup.suggestion)
        }
        onApplyParagraph={handleApplyParagraphFixes}
      />

      {/* ── Loading overlay ──
          FIX: show overlay when EITHER suggestionLoader OR isStreaming is true.
          This prevents the "All good" flash that appeared in the gap between
          the button click and the first stream chunk arriving.
      ── */}
      {showInitialLoader && (
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            bgcolor: "rgba(255,255,255,0.85)",
            zIndex: 10,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 1.5,
            borderRadius: R.lg,
          }}
        >
          <BeatLoader size={12} color={C.accent} loading />
          <Typography
            sx={{ fontSize: "0.8rem", color: C.textMuted, fontWeight: 500 }}
          >
            Analyzing your text…
          </Typography>
          <LinearProgress
            sx={{
              width: 120,
              height: 3,
              borderRadius: 2,
              bgcolor: C.accentLight,
              "& .MuiLinearProgress-bar": { bgcolor: C.accent },
            }}
          />
        </Box>
      )}

      {isCheckingSuggestions && suggestionArray.length > 0 && (
        <Box sx={{ px: 2, pt: 1, pb: 0.5 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <BeatLoader size={6} color={C.accent} loading />
            <Typography
              sx={{ fontSize: "0.72rem", color: C.textMuted, fontWeight: 600 }}
            >
              Analyzing more text...
            </Typography>
          </Box>
          <LinearProgress
            sx={{
              mt: 0.75,
              height: 2,
              borderRadius: 2,
              bgcolor: C.accentLight,
              "& .MuiLinearProgress-bar": { bgcolor: C.accent },
            }}
          />
        </Box>
      )}

      {suggestionArray.length > 0 && <ParagraphFixHint />}

      {/* ── Error type summary pills ── */}
      {suggestionArray.length > 0 && (
        <ErrorChipSummary
          errorCounts={errorCounts}
          C={C}
          R={R}
          getErrorConfig={getErrorConfig}
        />
      )}

      {/* ── Suggestion cards ── */}
      <Box
        sx={{
          px: 2,
          pb: 2,
          flex: 1,
          minHeight: 0,
          overflowY: "auto",
          overflowX: "auto",
        }}
      >
        {suggestionArray.length === 0 && !isCheckingSuggestions ? (
          <EmptyState />
        ) : (
          suggestionArray.map((suggestion, i) => (
            <div key={i} className="cgsuggestion" ref={accordionRef}>
              <SuggestionCard
                suggestion={suggestion}
                expanded={expanded}
                onExpand={handleExpand}
                onAccept={handleAccept}
                onIgnore={handleIgnore}
                mobileView={mobileView}
              />
            </div>
          ))
        )}
      </Box>
    </Box>
  );
};

export default SuggestionComp;
